import { useEffect, useState, useRef } from "react";
import logoImg from "./images/logo_dark.png";

// ═══════════════════════════════════════════
//  IMPORTĂ IMAGINILE TALE AICI
//  (înlocuiește cu căile corecte din proiectul tău)
// ═══════════════════════════════════════════
import imgRobotica       from "./images/robotica.JPG";
import imgRobotica2      from "./images/robotica2.JPG";
import imgLaborator      from "./images/laborator.JPG";
import imgLaborator2     from "./images/laborator2.JPG";
import imgProgramare     from "./images/programare.JPG";
import imgProgramare2    from "./images/programare2.JPG";
import imgOffice         from "./images/office.JPG";
import imgOffice2        from "./images/office2.JPG";
import imgMuzica         from "./images/muzica.jfif";
import imgMuzica2        from "./images/muzica2.jfif";
import imgActorie        from "./images/actorie.jpg";
import imgActorie2       from "./images/actorie2.jpg";
import imgDespreNoi      from "./images/despre_noi.JPG"; 
const PARTICLES = [
  { left: "6%",  size: 2, dur: 14, delay: 0  },
  { left: "18%", size: 1, dur: 19, delay: 3  },
  { left: "32%", size: 2, dur: 16, delay: 7  },
  { left: "50%", size: 1, dur: 22, delay: 1  },
  { left: "65%", size: 1, dur: 18, delay: 4  },
  { left: "78%", size: 3, dur: 12, delay: 5  },
  { left: "88%", size: 1, dur: 17, delay: 9  },
  { left: "42%", size: 1, dur: 20, delay: 11 },
];

const SocialIcons = {
  facebook: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3V2z"/>
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.98a8.21 8.21 0 004.76 1.52V7.05a4.84 4.84 0 01-1-.36z"/>
    </svg>
  ),
};

const NAV_LINKS = [
  { label: "Acasă",                 key: "acasa" },
  { label: "Despre noi",            key: "despre" },
  { label: "Academia",              key: "academia" },
  { label: "Dezvoltare software",   key: "software" },
  { label: "Curățenie Profesională", key: "curatenie" },
  { label: "Contact",               key: "contact" },
];

/* ═══════════════════════════════════════════
   ACADEMIA - Data  (câmpul "imagine" adăugat)
   ═══════════════════════════════════════════ */

const MATERII = [
  {
    id: 0,
    title: "Robotică",
    subtitlu: "Micul Inginer",
    descriereLunga: "• Preșcolar · Clasa Pregătitoare · Clasa I\n\nEducație integrată STEM prin intermediul seturilor Montessori — de la joc la înțelegerea noțiunilor de bază din domeniul ingineriei\n\nLaboratorul dedicat va susține dezvoltarea unui set de competențe specifice:\n\n◆ Corelarea formelor geometrice cu rolul funcțional al fiecărei piese din ansamblu;\n◆ Aplicarea principiilor simple de simetrie, stabilitate și funcționalitate mecanică;\n◆ Exersarea gândirii spațiale prin orientarea corectă a componentelor în plan bidimensional și tridimensional;\n◆ Identificarea și selectarea componentelor tehnice adecvate fiecărui tip de construcție;\n◆ Cultivarea atenției la detalii și a gândirii algoritmice prin parcursuri logice și secvențiale;\n◆ Dezvoltarea coordonării oculo-motorii prin manipularea pieselor și utilizarea uneltelor specifice;\n◆ Lucrul în echipă și dezvoltarea abilităților de comunicare într-un cadru colaborativ;\n◆ Observarea, evaluarea și corectarea erorilor survenite în procesul de asamblare.\n\n⚙️ Clasele a II-a · a III-a · a IV-a\n\nLaboratoare de programare cu Ozobot — primii pași în gândirea algoritmică\n\nActivitățile îmbină programare vizuală și logică algoritmică, oferind copiilor oportunitatea de a învăța prin joc. Laboratoarele sunt structurate pe două direcții complementare.\n\n🎨 Programarea prin coduri de culoare\n\nCei mici descoperă cum roboții pot fi programați, dezvoltând:\n◆ Înțelegerea noțiunii de algoritm ca succesiune de pași;\n◆ Recunoașterea codurilor de culoare pentru controlul direcției și al vitezei;\n◆ Gândirea logică prin anticiparea traseului și a reacțiilor robotului;\n◆ Atenția și precizia în realizarea traseelor;\n◆ Învățarea prin încercare și eroare, optimizând secvențele create.\n\n💻 Programare în Ozoblockly\n\nCopiii construiesc programe prin blocuri logice, similare limbajelor de programare reale, dezvoltându-și:\n◆ Gândirea algoritmică prin structurarea logică a instrucțiunilor;\n◆ Înțelegerea conceptelor de secvență, repetiție și condiții;\n◆ Rezolvarea problemelor prin descompunerea lor în pași simpli;\n◆ Competențe digitale într-un mediu interactiv și accesibil;\n◆ Creativitatea prin programe personalizate pentru controlul robotului.\n\n🌟 Prin îmbinarea celor două metode, copiii parcurg un traseu progresiv — de la interacțiunea vizuală la abstractizarea logicii de programare — consolidând bazele necesare în informatică și robotică.",
    varsta: "3-10 ani",
    durata: "50 min / ședință",
    nivel: "Începător → Avansat",
    side: "left",
    imagine: imgRobotica,
    imagine2: imgRobotica2,   // a doua imagine pentru Robotică
    iconPath: "M12 1l1.74 3.74L17.5 6.5l-3.76 1.76L12 12l-1.74-3.74L6.5 6.5l3.76-1.76zM4.5 13.5l1 2.15L7.65 16.5l-2.15.85-1 2.15-1-2.15L1.35 16.5l2.15-.85zM17 14l1.3 2.8L21.1 18l-2.8 1.2L17 22l-1.3-2.8L12.9 18l2.8-1.2z",
  },
  {
    id: 4,
    title: "Laborator Experimental",
    subtitlu: "Circuite Electrice",
    descriereLunga: "⚡ Laboratorul experimental de circuite electrice — o incursiune aplicată în universul fizicii!\n\nÎntr-o abordare educațională centrată pe învățarea experiențială și dezvoltarea competențelor STEM, laboratorul interactiv le propune copiilor construirea și testarea circuitelor electrice funcționale, utilizând kituri educaționale special concepute.\n\nLaboratorul urmărește dezvoltarea următoarelor competențe:\n\n◆ Aplicarea conceptelor fundamentale din electricitate — curent electric, tensiune și tipuri de conexiuni (serie și paralel) — în contexte practice\n◆ Înțelegerea relației cauză-efect prin observarea directă a funcționării circuitelor și a rolului fiecărei componente\n◆ Dezvoltarea gândirii logice și științifice prin formularea de ipoteze, testarea lor și interpretarea rezultatelor experimentale\n◆ Exersarea gândirii algoritmice prin parcurgerea etapelor necesare realizării unui circuit funcțional\n◆ Consolidarea coordonării mână-ochi și a preciziei motrice prin manipularea și asamblarea componentelor electrice\n◆ Stimularea creativității prin proiectarea unor circuite originale, pornind de la modelele studiate\n◆ Dezvoltarea abilităților de colaborare și comunicare în cadrul activităților desfășurate în echipă\n\n🌟 Laboratorul oferă elevilor oportunitatea de a realiza tranziția de la teorie la practică — transformând noțiunile abstracte din fizică în experiențe concrete și ușor de înțeles, într-un mediu sigur și adaptat vârstei lor.",
    varsta: "9-11 ani",
    durata: "50 min / ședință",
    nivel: "Începător → Avansat",
    side: "right",
    imagine: imgLaborator,
    imagine2: imgLaborator2,  // a doua imagine pentru Laborator
    iconPath: "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  },
  {
    id: 1,
    title: "Programare",
    subtitlu: "Programatorii Ingenioși",
    descriereLunga: "💻 Cursuri de Programare — de la logică la cod!\n\nÎntr-o abordare educațională modernă, orientată spre dezvoltarea competențelor digitale, cursurile de programare îi invită pe elevi într-o călătorie progresivă prin universul algoritmicii și al dezvoltării software.\n\nParcursul educațional este structurat în funcție de nivelul de vârstă și experiența fiecărui cursant, asigurând o tranziție fluidă de la conceptele de bază la tehnici avansate de programare.\n\n🔹 Clasele a VI-a · a VII-a · a VIII-a\n\nÎn această etapă, elevii pășesc în lumea programării prin intermediul unor limbaje și platforme accesibile, dezvoltând:\n\n◆ Înțelegerea conceptelor fundamentale — variabile, tipuri de date, operatori și expresii\n◆ Gândirea algoritmică prin structurarea logică a problemelor în pași clari și secvențiali\n◆ Utilizarea structurilor de control — condiții, bucle și funcții — pentru crearea programelor funcționale\n◆ Rezolvarea problemelor prin descompunerea acestora în subprobleme mai simple\n◆ Familiarizarea cu medii de dezvoltare și instrumente utilizate în industria IT\n◆ Stimularea creativității prin realizarea unor proiecte proprii — jocuri simple, animații și aplicații interactive\n\n🔸 Clasele a IX-a · a X-a · a XI-a · a XII-a\n\nLa nivel avansat, cursanții aprofundează concepte complexe de programare, pregătindu-se pentru performanță academică și carieră în tehnologie:\n\n◆ Stăpânirea unui limbaj de programare modern — structuri de date, algoritmi de sortare și căutare\n◆ Programarea orientată pe obiecte — clase, obiecte, moștenire și polimorfism\n◆ Dezvoltarea aplicațiilor web și desktop prin utilizarea tehnologiilor actuale\n◆ Rezolvarea problemelor de algoritmică pentru olimpiade și concursuri de informatică\n◆ Înțelegerea principiilor de bază ale bazelor de date și interacțiunea cu acestea\n◆ Lucrul cu proiecte reale, cultivând capacitatea de planificare, documentare și livrare a unui produs software\n\n🌟 Cursurile de programare nu sunt doar lecții de cod — sunt o școală a gândirii logice, a perseverenței și a creativității aplicate, pregătind fiecare cursant pentru provocările lumii digitale de mâine.",
    varsta: "13-19 ani",
    durata: "60 min / ședință cls. VI-VIII, 90 min / ședință cls IX-XII",
    nivel: "Începător → Avansat",
    side: "left",
    imagine: imgProgramare,
    imagine2: imgProgramare2,
    iconPath: "M2 3h20v14a2 2 0 01-2 2H4a2 2 0 01-2-2V3zM8 21h8M12 17v4M7 8l3 3-3 3M13 14h4",
  },
  {
    id: 5,
    title: "Office for Kids",
    subtitlu: "Micul Profesionist",
    descriereLunga: "🖥️ Office for Kids — primii pași în lumea productivității digitale!\n\nÎntr-o abordare educațională practică și accesibilă, cursurile Office for Kids introduc elevii în universul aplicațiilor Microsoft Office, oferindu-le instrumentele digitale esențiale pentru școală, dar și pentru viața de zi cu zi.\n\nParcursul este conceput progresiv, adaptat nivelului fiecărei clase, asigurând o învățare solidă și aplicată.\n\n📝 Microsoft Word — Arta comunicării scrise\n\n◆ Crearea și formatarea documentelor text — fonturi, paragrafe, titluri și stiluri\n◆ Inserarea și editarea imaginilor, tabelelor și elementelor grafice\n◆ Redactarea corectă a unui document — scrisori, referate și prezentări școlare\n◆ Utilizarea instrumentelor de verificare ortografică și gramaticală\n◆ Exportarea și salvarea documentelor în formate diverse\n\n📊 Microsoft Excel — Introducere în lumea datelor\n\n◆ Înțelegerea structurii unei foi de calcul — celule, rânduri și coloane\n◆ Introducerea și organizarea datelor în tabele simple și funcționale\n◆ Utilizarea formulelor și funcțiilor de bază — sumă, medie, număr\n◆ Crearea graficelor și a diagramelor pentru vizualizarea informațiilor\n◆ Aplicarea formatării condiționale pentru interpretarea intuitivă a datelor\n\n🎨 Microsoft PowerPoint — Prezintă cu impact!\n\n◆ Crearea prezentărilor vizuale atractive și bine structurate\n◆ Utilizarea șabloanelor, animațiilor și tranzițiilor pentru un impact vizual puternic\n◆ Organizarea logică a informației pe slide-uri clare și concise\n◆ Inserarea elementelor multimedia — imagini, videoclipuri și grafice\n◆ Susținerea unei prezentări în fața publicului — tehnici de comunicare și încredere în sine\n\n🌟 Office for Kids este o investiție în autonomia digitală a copilului, pregătindu-l cu instrumentele necesare pentru succes școlar și profesional.",
    varsta: "9-13 ani",
    durata: "50 min / ședință",
    nivel: "Începător → Avansat",
    side: "right",
    imagine: imgOffice,
    imagine2: imgOffice2,
    iconPath: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM8 10h8M8 14h5",
  },
  {
    id: 2,
    title: "Muzică populară",
    subtitlu: "Micul Artist",
    descriereLunga: "🎤 Cursuri de Muzică Populară – Dezvoltă-ți talentul autentic!\nOferim cursuri de muzică populară individuale (one-to-one), dedicate copiilor și tinerilor pasionați de folclor și tradiție. Lecțiile sunt personalizate și au o durată flexibilă, între 1 oră și 1 oră și 30 de minute, pentru a asigura progres real și atenție maximă fiecărui cursant.\n\n🌟 Ce înveți în cadrul cursurilor?\nSub îndrumarea unor artiști consacrați, cursanții vor dobândi:\ntehnici corecte de respirație · dicție clară și expresivă · postură scenică · interpretare și repertoriu de muzică populară autentică\n\n🎶 Învață de la profesioniști\nCursurile sunt susținute de artiști renumiți ai muzicii populare românești, precum:\nNicu Mâță · Claudia Ghițulescu · Ionela Stăncioi · Gabriel Dumitru ect\n\nExperiența și implicarea lor oferă elevilor o perspectivă reală asupra unei cariere în domeniu.\n\nAvantajele cursurilor noastre\nCeea ce ne diferențiază este implicarea directă în dezvoltarea artistică a fiecărui copil:\nCrearea propriilor melodii · Dezvoltarea unui stil muzical unic și a unei identități artistice · Posibilitatea de a realiza videoclipuri profesionale · Promovare online și offline · Apariții la televiziuni naționale · Sprijin pentru costume populare · Conectare directă cu lumea artistică\n\n🌱 Un drum real spre o carieră\nAceste cursuri nu sunt doar lecții de muzică – sunt un start real într-o carieră artistică, ghidat de oameni care trăiesc și iubesc folclorul românesc.",
    varsta: "6-18 ani",
    durata: "60-90 min / ședință",
    nivel: "Începător → Avansat",
    side: "left",
    imagine: imgMuzica,
    imagine2: imgMuzica2,
    iconPath: "M9 18V5l12-2v13M6 18a3 3 0 100-6 3 3 0 000 6zM18 16a3 3 0 100-6 3 3 0 000 6z",
  },
  {
    id: 3,
    title: "Dezvoltare personală prin tehnici de actorie",
    subtitlu: "Micul Actor",
    descriereLunga: "🎭 Dezvoltare personală prin tehnici de actorie\n\nÎntr-o abordare educațională inovatoare, cursurile dedicate dezvoltării personale prin tehnici de actorie îmbină arta teatrului cu formarea competențelor esențiale pentru viață — comunicare, exprimare emoțională, încredere în sine și lucru în echipă.\n\nActivitățile sunt concepute pentru copii și adulți deopotrivă, adaptate nivelului și nevoilor fiecărui participant, într-un mediu sigur, creativ și stimulativ.\n\n🎤 Voce și dicție — puterea cuvântului rostit\n\n◆ Exerciții de respirație corectă și control al vocii\n◆ Dicție clară și expresivă prin tehnici specifice artei teatrale\n◆ Modularea tonului, a ritmului și intensității vocale în funcție de context\n◆ Eliminarea blocajelor de vorbire și dobândirea fluenței în exprimare\n\n Expresivitate și limbaj non-verbal:\n\n◆ Conștientizarea și controlul limbajului corporal — postură, gestică și mimică\n◆ Exprimarea autentică a emoțiilor prin mișcare și prezență scenică\n◆ Tehnici de relaxare și deconectare\n◆ Construirea unui personaj prin observarea și înțelegerea psihologiei umane\n\n🌱 Dezvoltare personală și abilități sociale:\n\n◆ Sporirea încrederii în sine\n◆ Dezvoltarea empatiei prin interpretarea unor perspective și trăiri diverse\n◆ Stimularea creativității și a gândirii spontane prin improvizație\n◆ Cultivarea capacității de ascultare activă și reacție autentică în relație cu ceilalți\n◆ Lucrul în echipă, cooperarea și construirea unui spirit de grup coeziv\n\n✨ Scenă și performanță:\n\n◆ Familiarizarea cu spațiul scenic și dinamica unei reprezentații\n◆ Interpretarea unor scene și texte dramatice adaptate vârstei\n◆ Participarea la spectacole și prezentări în fața publicului\n◆ Construirea unui repertoriu personal de tehnici de exprimare și prezență\n\n🌟 Aceste cursuri sunt despre curajul de a fi tu însuți, despre forța de a te exprima și despre arta de a te conecta autentic cu cei din jur.",
    varsta: "copii, tineri & adulți",
    durata: "90 min / ședință",
    nivel: "Începător → Avansat",
    side: "right",
    imagine: imgActorie,
    imagine2: imgActorie2,
    iconPath: "M3 8c0-3.3 2.7-6 6-6s6 2.7 6 6c0 4-3 7-6 7S3 12 3 8zM6.5 7a.5.5 0 110-1 .5.5 0 010 1zM11.5 7a.5.5 0 110-1 .5.5 0 010 1zM6 10.5c0 1.1 1.3 2 3 2s3-.9 3-2M12 14c1 1.5 2.5 2 4 2 2.8 0 5-2.2 5-5s-2.2-5-5-5c-.8 0-1.5.2-2.2.5M17.5 10a.5.5 0 110-1 .5.5 0 010 1zM14 13c.5.3 1.2.5 2 .5s1.5-.2 2-.5",
  },
];

/* ═══════════════════════════════════════════
   useWindowWidth hook
   ═══════════════════════════════════════════ */
function useWindowWidth() {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return width;
}

/* ═══════════════════════════════════════════
   ARCHITECTURAL GRID BACKGROUND COMPONENT
   ═══════════════════════════════════════════ */

function ArchitecturalGrid() {
  const svgGrid = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <defs>
        <pattern id="minorGrid" width="20" height="20" patternUnits="userSpaceOnUse">
          <path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(201,168,76,0.45)" stroke-width="0.8"/>
        </pattern>
        <pattern id="majorGrid" width="100" height="100" patternUnits="userSpaceOnUse">
          <rect width="100" height="100" fill="url(#minorGrid)"/>
          <path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(201,168,76,0.80)" stroke-width="1.4"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#majorGrid)"/>
    </svg>
  `;
  const encodedSvg = `data:image/svg+xml,${encodeURIComponent(svgGrid.trim())}`;
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none",
        backgroundImage: `url("${encodedSvg}")`,
        backgroundRepeat: "repeat", backgroundSize: "100px 100px",
        maskImage: "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.8) 6%, rgba(0,0,0,1) 12%, rgba(0,0,0,1) 88%, rgba(0,0,0,0.8) 94%, transparent 100%), linear-gradient(to right, transparent 0%, rgba(0,0,0,1) 4%, rgba(0,0,0,1) 96%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.8) 6%, rgba(0,0,0,1) 12%, rgba(0,0,0,1) 88%, rgba(0,0,0,0.8) 94%, transparent 100%), linear-gradient(to right, transparent 0%, rgba(0,0,0,1) 4%, rgba(0,0,0,1) 96%, transparent 100%)",
        maskComposite: "intersect", WebkitMaskComposite: "destination-in", opacity: 1,
      }}
    />
  );
}

/* ═══════════════════════════════════════════
   ACADEMIA - Timeline Component (RESPONSIVE)
   ═══════════════════════════════════════════ */

function AcademiaTimeline({ navigate }) {
  const [activeId, setActiveId] = useState(null);
  const [visibleItems, setVisibleItems] = useState([]);
  const itemRefs = useRef([]);
  const w = useWindowWidth();
  const isMobile = w < 768;

  useEffect(() => {
    const observers = [];
    itemRefs.current.forEach((el, i) => {
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setVisibleItems((prev) => (prev.includes(i) ? prev : [...prev, i]));
            }, i * 150);
          }
        },
        { threshold: 0, rootMargin: "200px" }
      );
      obs.observe(el);
      observers.push(obs);
    });
    const fallback = setTimeout(() => {
      setVisibleItems(MATERII.map((_, i) => i));
    }, 2000);
    return () => { observers.forEach((o) => o.disconnect()); clearTimeout(fallback); };
  }, []);

  const handleClick = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
  };

  // ─── MOBILE VERSION ───────────────────────────────────────────────────────
  if (isMobile) {
    return (
      <div style={{ width: "100%", maxWidth: 880, margin: "0 auto", padding: "0 16px 40px" }}>
        {MATERII.map((m, i) => {
          const isActive = activeId === m.id;
          const isVisible = visibleItems.includes(i);
          return (
            <div
              key={m.id}
              ref={(el) => (itemRefs.current[i] = el)}
              style={{
                marginBottom: 20,
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(30px)",
                transition: "opacity 0.7s ease, transform 0.7s cubic-bezier(0.34,1.56,0.64,1)",
                padding: m.imagine2 ? "0 10px" : "0",
              }}
            >
              {/* Imagini deasupra cardului pe mobil */}
              {m.imagine && (
                <div style={{
                  display: "flex",
                  gap: 6,
                  justifyContent: "center",
                  padding: "0",
                  marginBottom: -1,
                }}>
                  {/* Imaginea 1 */}
                  <div style={{
                    flex: m.imagine2 ? "1 1 0" : "0 0 auto",
                    width: m.imagine2 ? undefined : "70%",
                    height: 160,
                    borderRadius: "10px 10px 0 0",
                    overflow: "hidden",
                    border: isActive
                      ? "1px solid rgba(201,168,76,0.5)"
                      : "1px solid rgba(201,168,76,0.2)",
                    borderBottom: "none",
                    position: "relative",
                    transition: "border-color 0.45s ease",
                  }}>
                    <img src={m.imagine} alt={m.title} style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center 36%",
                      display: "block",
                      filter: isActive
                        ? "brightness(0.90) saturate(1.08)"
                        : "brightness(0.68) saturate(0.85)",
                      transform: isActive ? "scale(1.03)" : "scale(1)",
                      transition: "filter 0.5s ease, transform 0.6s ease",
                    }} />
                    <div style={{
                      position: "absolute", bottom: 0, left: 0, right: 0, height: 70,
                      background: "linear-gradient(to top, rgba(201,168,76,0.55) 0%, rgba(180,130,40,0.2) 35%, transparent 100%)",
                      pointerEvents: "none",
                    }} />
                  </div>
                  {/* Imaginea 2 — doar dacă există */}
                  {m.imagine2 && (
                    <div style={{
                      flex: "1 1 0",
                      height: 160,
                      borderRadius: "10px 10px 0 0",
                      overflow: "hidden",
                      border: isActive
                        ? "1px solid rgba(201,168,76,0.38)"
                        : "1px solid rgba(201,168,76,0.15)",
                      borderBottom: "none",
                      position: "relative",
                      transition: "border-color 0.45s ease",
                    }}>
                      <img src={m.imagine2} alt={m.title} style={{
                        width: "100%", height: "100%", objectFit: "cover", objectPosition: m.id === 0 ? "center 60%" : "center 35%", display: "block",
                        filter: isActive
                          ? "brightness(0.84) saturate(1.04)"
                          : "brightness(0.60) saturate(0.80)",
                        transform: isActive ? "scale(1.05)" : "scale(1.01)",
                        transition: "filter 0.5s ease 0.05s, transform 0.6s ease 0.05s",
                      }} />
                      <div style={{
                        position: "absolute", bottom: 0, left: 0, right: 0, height: 70,
                        background: "linear-gradient(to top, rgba(201,168,76,0.55) 0%, rgba(180,130,40,0.2) 35%, transparent 100%)",
                        pointerEvents: "none",
                      }} />
                    </div>
                  )}
                </div>
              )}

              {/* Punte gradient între imagini și card */}
              {m.imagine && (
                <div style={{
                  height: 18,
                  background: isActive
                    ? "linear-gradient(to bottom, rgba(201,168,76,0.45), rgba(18,10,2,0.85))"
                    : "linear-gradient(to bottom, rgba(201,168,76,0.45), #b08030)",
                  margin: "0",
                  transition: "background 0.45s ease",
                }} />
              )}

              <div
                onClick={() => handleClick(m.id)}
                style={{
                  width: "100%", cursor: "pointer", position: "relative",
                  background: isActive
                    ? "rgba(18,10,2,0.85)"
                    : "linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030)",
                  border: isActive
                    ? "1px solid rgba(201,168,76,0.35)"
                    : "1px solid rgba(180,130,40,0.5)",
                  borderRadius: m.imagine ? "0 0 12px 12px" : 12,
                  padding: "24px 20px 18px",
                  transition: "all 0.45s ease",
                  borderTop: "none",
                  boxShadow: isActive
                    ? "0 12px 48px rgba(201,168,76,0.18)"
                    : "0 8px 32px rgba(180,130,40,0.3)",
                }}
              >
                <div style={{
                  position: "absolute", top: 0,
                  left: isActive ? "8%" : "10%", right: isActive ? "8%" : "10%",
                  height: 1,
                  background: isActive
                    ? "linear-gradient(to right, transparent, rgba(201,168,76,0.3), transparent)"
                    : "linear-gradient(to right, transparent, rgba(20,10,2,0.15), transparent)",
                  transition: "left 0.3s, right 0.3s",
                }} />
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 10 }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: "50%",
                    border: isActive ? "1px solid rgba(201,168,76,0.4)" : "1px solid rgba(20,10,2,0.25)",
                    background: isActive ? "rgba(201,168,76,0.08)" : "rgba(20,10,2,0.08)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0, transition: "all 0.45s ease",
                    boxShadow: isActive ? "0 0 20px rgba(201,168,76,0.15)" : "none",
                  }}>
                    <svg viewBox="0 0 24 24" style={{
                      width: 20, height: 20,
                      stroke: isActive ? "#c9a84c" : "rgba(20,10,2,0.8)",
                      fill: "none", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round",
                      transition: "stroke 0.45s ease",
                    }}>
                      <path d={m.iconPath} />
                    </svg>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
                    <span style={{
                      fontFamily: "'Cinzel', serif", fontSize: 9, fontWeight: 700,
                      letterSpacing: "0.3em", color: isActive ? "#f0d898" : "rgba(20,10,2,0.65)",
                      textTransform: "uppercase", transition: "color 0.45s ease",
                    }}>{m.subtitlu}</span>
                    <span style={{
                      fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 600,
                      letterSpacing: "0.1em", textTransform: "uppercase", lineHeight: 1.2,
                      transition: "all 0.45s ease",
                      ...(isActive
                        ? { background: "linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }
                        : { background: "none", WebkitBackgroundClip: "unset", WebkitTextFillColor: "rgba(20,10,2,0.95)", backgroundClip: "unset" }),
                    }}>{m.title}</span>
                  </div>
                  <span style={{ fontFamily: "'Cinzel', serif", fontSize: 9, color: isActive ? "#f0d898" : "rgba(20,10,2,0.4)", transition: "color 0.45s ease", flexShrink: 0 }}>
                    {isActive ? "▲" : "▼"}
                  </span>
                </div>
                <div style={{ maxHeight: isActive ? 2000 : 0, overflow: "hidden", transition: "max-height 0.5s cubic-bezier(0.4,0,0.2,1)" }}>
                  <div style={{ height: 1, margin: "4px 0 14px", background: isActive ? "linear-gradient(to right, transparent, rgba(240,216,152,0.25), transparent)" : "linear-gradient(to right, transparent, rgba(20,10,2,0.12), transparent)" }} />
                  <p style={{
                    fontFamily: "'Cormorant Garamond', serif", fontSize: 14, fontWeight: 600,
                    color: isActive ? "#f0d898" : "rgba(20,10,2,0.8)", lineHeight: 1.8,
                    letterSpacing: "0.04em", margin: "0 0 14px", whiteSpace: "pre-line", textAlign: "justify",
                    transition: "color 0.45s ease",
                  }}>{m.descriereLunga}</p>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {[m.varsta, m.durata, m.nivel].map((label, bi) => (
                      <div key={bi} style={{
                        padding: "6px 13px",
                        border: isActive ? "1px solid rgba(240,216,152,0.35)" : "1px solid rgba(20,10,2,0.2)",
                        borderRadius: 2,
                        background: isActive ? "rgba(240,216,152,0.08)" : "rgba(20,10,2,0.1)",
                        transition: "all 0.45s ease",
                      }}>
                        <span style={{ fontFamily: "'Cinzel', serif", fontSize: 10, fontWeight: 700, color: isActive ? "#f0d898" : "rgba(20,10,2,0.8)", letterSpacing: "0.06em", transition: "color 0.45s ease" }}>
                          {label}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <div style={{
            display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 12,
            background: "transparent", border: "1px solid rgba(201,168,76,0.55)",
            borderRadius: 3, padding: "22px 36px", position: "relative",
          }}>
            <div style={{ position: "absolute", top: 0, left: "15%", right: "15%", height: 1, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.5), transparent)" }} />
            <svg viewBox="0 0 24 24" style={{ width: 30, height: 30, stroke: "rgba(201,168,76,0.85)", fill: "rgba(201,168,76,0.08)", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", filter: "drop-shadow(0 0 6px rgba(201,168,76,0.45))" }}>
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 700, color: "rgba(235,210,155,0.90)", letterSpacing: "0.1em" }}>
              Aventura ta începe{" "}
              <span onClick={() => navigate("contact")} style={{ color: "#f0d878", cursor: "pointer", borderBottom: "1px solid rgba(240,216,120,0.5)", paddingBottom: 1, fontWeight: 600 }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#fff5b0")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#f0d878")}>
                aici
              </span>!
            </span>
          </div>
        </div>
      </div>
    );
  }

  // ─── DESKTOP VERSION ──────────────────────────────────────────────────────
  return (
    <div style={{ position: "relative", width: "100%", maxWidth: 1100, margin: "0 auto", padding: "0 20px 40px" }}>
      {/* Linia verticală centrală */}
      <div style={{
        position: "absolute", left: "50%", top: 0, bottom: 40, width: 1,
        transform: "translateX(-50%)",
        background: "linear-gradient(to bottom, transparent, rgba(201,168,76,0.25), rgba(201,168,76,0.15), transparent)",
        zIndex: 0,
      }} />

      {MATERII.map((m, i) => {
        const isLeft = m.side === "left";
        const isActive = activeId === m.id;
        const isVisible = visibleItems.includes(i);

        return (
          <div
            key={m.id}
            ref={(el) => (itemRefs.current[i] = el)}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 16,
              marginBottom: 56,
              position: "relative",
              zIndex: 1,
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : `translateX(${isLeft ? "-50px" : "50px"})`,
              transition: "opacity 0.7s ease, transform 0.7s cubic-bezier(0.34,1.56,0.64,1)",
            }}
          >
            {/* ── CARD (stânga sau dreapta) ── */}
            <div
              onClick={() => handleClick(m.id)}
              style={{
                width: 360,
                flexShrink: 0,
                order: isLeft ? 0 : 2,
                cursor: "pointer",
                position: "relative",
                background: isActive
                  ? "rgba(18,10,2,0.85)"
                  : "linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030)",
                border: isActive
                  ? "1px solid rgba(201,168,76,0.35)"
                  : "1px solid rgba(180,130,40,0.5)",
                borderRadius: 3,
                padding: "28px 26px 20px",
                transition: "all 0.45s ease",
                boxShadow: isActive
                  ? "0 12px 48px rgba(201,168,76,0.18)"
                  : "0 8px 32px rgba(180,130,40,0.3)",
                transform: isActive ? "translateY(-3px)" : "translateY(0)",
              }}
            >
              <div style={{
                position: "absolute", top: 0,
                left: isActive ? "8%" : "10%", right: isActive ? "8%" : "10%",
                height: 1,
                background: isActive
                  ? "linear-gradient(to right, transparent, rgba(201,168,76,0.3), transparent)"
                  : "linear-gradient(to right, transparent, rgba(20,10,2,0.15), transparent)",
                transition: "left 0.3s, right 0.3s",
              }} />

              <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 12 }}>
                <div style={{
                  width: 52, height: 52, borderRadius: "50%",
                  border: isActive ? "1px solid rgba(201,168,76,0.4)" : "1px solid rgba(20,10,2,0.25)",
                  background: isActive ? "rgba(201,168,76,0.08)" : "rgba(20,10,2,0.08)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0, transition: "all 0.45s ease",
                  boxShadow: isActive ? "0 0 20px rgba(201,168,76,0.15)" : "none",
                }}>
                  <svg viewBox="0 0 24 24" style={{
                    width: 22, height: 22,
                    stroke: isActive ? "#c9a84c" : "rgba(20,10,2,0.8)",
                    fill: "none", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round",
                    transition: "stroke 0.45s ease",
                  }}>
                    <path d={m.iconPath} />
                  </svg>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  <span style={{
                    fontFamily: "'Cinzel', serif", fontSize: 9, fontWeight: 700,
                    letterSpacing: "0.3em", color: isActive ? "#f0d898" : "rgba(20,10,2,0.65)",
                    textTransform: "uppercase", transition: "color 0.45s ease",
                  }}>{m.subtitlu}</span>
                  <span style={{
                    fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 600,
                    letterSpacing: "0.12em", textTransform: "uppercase", lineHeight: 1.2,
                    transition: "all 0.45s ease",
                    ...(isActive
                      ? { background: "linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }
                      : { background: "none", WebkitBackgroundClip: "unset", WebkitTextFillColor: "rgba(20,10,2,0.95)", backgroundClip: "unset" }),
                  }}>{m.title}</span>
                </div>
              </div>

              <div style={{ maxHeight: isActive ? 2000 : 0, overflow: "hidden", transition: "max-height 0.5s cubic-bezier(0.4,0,0.2,1)" }}>
                <div style={{ height: 1, margin: "4px 0 14px", background: isActive ? "linear-gradient(to right, transparent, rgba(240,216,152,0.25), transparent)" : "linear-gradient(to right, transparent, rgba(20,10,2,0.12), transparent)" }} />
                <p style={{
                  fontFamily: "'Cormorant Garamond', serif", fontSize: 14, fontWeight: 600,
                  color: isActive ? "#f0d898" : "rgba(20,10,2,0.8)", lineHeight: 1.8,
                  letterSpacing: "0.04em", margin: "0 0 16px", whiteSpace: "pre-line", textAlign: "justify",
                  transition: "color 0.45s ease",
                }}>{m.descriereLunga}</p>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {[m.varsta, m.durata, m.nivel].map((label, bi) => (
                    <div key={bi} style={{
                      padding: "6px 15px",
                      border: isActive ? "1px solid rgba(240,216,152,0.35)" : "1px solid rgba(20,10,2,0.2)",
                      borderRadius: 2,
                      background: isActive ? "rgba(240,216,152,0.08)" : "rgba(20,10,2,0.1)",
                      transition: "all 0.45s ease",
                    }}>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 10, fontWeight: 700, color: isActive ? "#f0d898" : "rgba(20,10,2,0.8)", letterSpacing: "0.06em", transition: "color 0.45s ease" }}>
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
                <span style={{
                  fontFamily: "'Cinzel', serif", fontSize: 9, letterSpacing: "0.15em",
                  color: isActive ? "#f0d898" : "rgba(20,10,2,0.5)",
                  textTransform: "uppercase", padding: "4px 12px",
                  border: isActive ? "1px solid rgba(240,216,152,0.3)" : "1px solid rgba(20,10,2,0.15)",
                  borderRadius: 2, transition: "all 0.45s ease",
                }}>
                  {isActive ? "▲ Închide" : "Descoperă ▼"}
                </span>
              </div>

              {/* Săgeata spre centru */}
              <div style={{
                position: "absolute", top: "50%",
                ...(isLeft ? { right: -10 } : { left: -10 }),
                transform: "translateY(-50%)",
                width: 0, height: 0,
                borderTop: "10px solid transparent",
                borderBottom: "10px solid transparent",
                ...(isLeft
                  ? { borderLeft: isActive ? "10px solid rgba(201,168,76,0.35)" : "10px solid rgba(180,130,40,0.5)" }
                  : { borderRight: isActive ? "10px solid rgba(201,168,76,0.35)" : "10px solid rgba(180,130,40,0.5)" }),
                transition: "border-color 0.45s",
              }} />
            </div>

            {/* ── BUTON CIRCULAR CENTRU ── */}
            <div
              onClick={() => handleClick(m.id)}
              style={{
                order: 1,
                position: "relative",
                zIndex: 2,
                width: isActive ? 50 : 42, height: isActive ? 50 : 42,
                borderRadius: "50%",
                border: isActive ? "1px solid rgba(201,168,76,0.45)" : "1px solid rgba(180,130,40,0.5)",
                background: isActive ? "rgba(14,8,2,0.9)" : "linear-gradient(160deg, #c9a050, #dbb860, #c09040)",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.45s cubic-bezier(0.34,1.56,0.64,1)",
                boxShadow: isActive
                  ? "0 0 0 6px rgba(201,168,76,0.08), 0 0 24px rgba(201,168,76,0.2)"
                  : "0 0 0 4px rgba(180,130,40,0.15), 0 4px 16px rgba(180,130,40,0.3)",
                flexShrink: 0,
              }}
            >
              <svg viewBox="0 0 24 24" style={{
                width: isActive ? 22 : 18, height: isActive ? 22 : 18,
                stroke: isActive ? "#c9a84c" : "rgba(20,10,2,0.7)",
                fill: "none", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round",
                transition: "all 0.45s",
              }}>
                <path d={m.iconPath} />
              </svg>
            </div>

            {/* ── IMAGINI pe partea opusă cardului ── */}
            <div
              style={{
                width: 312,
                flexShrink: 0,
                order: isLeft ? 2 : 0,
                display: "flex",
                alignItems: "center",
                justifyContent: isLeft ? "flex-start" : "flex-end",
                opacity: isVisible ? 1 : 0,
                transition: "opacity 0.8s ease 0.2s",
              }}
            >
              {m.imagine && (
                <div style={{ display: "flex", flexDirection: "row", gap: 8, alignItems: "stretch" }}>
                  {/* Imaginea 1 — mai lată dacă nu există imagine2 */}
                  <div style={{
                    width: m.imagine2 ? 148 : 220,
                    height: 108,
                    borderRadius: 12,
                    overflow: "hidden",
                    border: isActive ? "1px solid rgba(201,168,76,0.45)" : "1px solid rgba(201,168,76,0.18)",
                    boxShadow: isActive ? "0 10px 30px rgba(0,0,0,0.6)" : "0 5px 20px rgba(0,0,0,0.45)",
                    transition: "all 0.5s ease",
                    position: "relative",
                    flexShrink: 0,
                  }}>
                    <img src={m.imagine} alt={m.title} style={{
                      width: "100%", height: "100%", objectFit: "cover", display: "block",
                      filter: isActive ? "brightness(0.92) saturate(1.05)" : "brightness(0.62) saturate(0.8)",
                      transform: isActive ? "scale(1.06)" : "scale(1)",
                      transition: "filter 0.5s ease, transform 0.6s ease",
                    }} />
                    <div style={{
                      position: "absolute", bottom: 0, left: 0, right: 0, height: 2,
                      background: isActive
                        ? "linear-gradient(to right, transparent, rgba(201,168,76,0.7), transparent)"
                        : "linear-gradient(to right, transparent, rgba(201,168,76,0.2), transparent)",
                      transition: "background 0.5s ease",
                    }} />
                  </div>
                  {/* Imaginea 2 — doar dacă există */}
                  {m.imagine2 && (
                    <div style={{
                      width: 148, height: 108, borderRadius: 12, overflow: "hidden",
                      border: isActive ? "1px solid rgba(201,168,76,0.35)" : "1px solid rgba(201,168,76,0.12)",
                      boxShadow: isActive ? "0 10px 30px rgba(0,0,0,0.5)" : "0 5px 20px rgba(0,0,0,0.35)",
                      transition: "all 0.5s ease 0.05s", position: "relative", flexShrink: 0,
                    }}>
                      <img src={m.imagine2} alt={m.title} style={{
                        width: "100%", height: "100%", objectFit: "cover", display: "block",
                        filter: isActive ? "brightness(0.88) saturate(1.0)" : "brightness(0.55) saturate(0.75)",
                        transform: isActive ? "scale(1.06)" : "scale(1)",
                        transition: "filter 0.5s ease 0.05s, transform 0.6s ease 0.05s",
                      }} />
                      <div style={{
                        position: "absolute", bottom: 0, left: 0, right: 0, height: 2,
                        background: isActive
                          ? "linear-gradient(to right, transparent, rgba(201,168,76,0.5), transparent)"
                          : "linear-gradient(to right, transparent, rgba(201,168,76,0.15), transparent)",
                        transition: "background 0.5s ease",
                      }} />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}

      {/* CTA final */}
      <div style={{ textAlign: "center", position: "relative", zIndex: 1, marginTop: 20 }}>
        <div style={{
          display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 14,
          background: "transparent", border: "1px solid rgba(201,168,76,0.55)",
          borderRadius: 3, padding: "28px 60px", position: "relative",
        }}>
          <div style={{ position: "absolute", top: 0, left: "15%", right: "15%", height: 1, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.55), transparent)" }} />
          <svg viewBox="0 0 24 24" style={{ width: 36, height: 36, stroke: "rgba(201,168,76,0.90)", fill: "rgba(201,168,76,0.10)", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", filter: "drop-shadow(0 0 8px rgba(201,168,76,0.55))" }}>
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 700, color: "rgba(235,210,155,0.92)", letterSpacing: "0.1em" }}>
            Aventura ta începe{" "}
            <span onClick={() => navigate("contact")} style={{ color: "#f0d878", cursor: "pointer", borderBottom: "1px solid rgba(240,216,120,0.5)", paddingBottom: 1, fontWeight: 600 }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#fff5b0")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#f0d878")}>
              aici
            </span>!
          </span>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════
   ACADEMIA - Page Component
   ═══════════════════════════════════════════ */

function PaginaAcademia({ navigate }) {
  const w = useWindowWidth();
  const isMobile = w < 768;

  return (
    <main style={{
      position: "relative", zIndex: 3,
      display: "flex", flexDirection: "column", alignItems: "center",
      padding: isMobile ? "90px 0 40px" : "110px 0 60px",
      width: "100%", overflowX: "hidden",
    }}>
      <ArchitecturalGrid />

      <div style={{ position: "relative", width: "100%", marginBottom: 20, overflowX: "clip", overflowY: "visible" }}>
        <div style={{
          position: "absolute",
          top: isMobile ? "-15%" : "-10%", left: "0", right: "0",
          height: isMobile ? "130%" : "120%",
          display: "flex", alignItems: "center", justifyContent: "center",
          pointerEvents: "none", zIndex: 0,
          animation: "academiaFadeIn 2.5s ease-out both",
        }}>
          <svg viewBox="0 0 1200 700" preserveAspectRatio="xMidYMid slice"
            style={{
              width: "100%", height: "100%", opacity: 1,
              maskImage: isMobile
                ? "radial-gradient(ellipse 100% 92% at 50% 48%, rgba(0,0,0,1) 30%, rgba(0,0,0,0.7) 65%, transparent 90%)"
                : "radial-gradient(ellipse 95% 95% at 50% 52%, rgba(0,0,0,1) 40%, rgba(0,0,0,0.6) 70%, transparent 90%)",
              WebkitMaskImage: isMobile
                ? "radial-gradient(ellipse 100% 92% at 50% 48%, rgba(0,0,0,1) 30%, rgba(0,0,0,0.7) 65%, transparent 90%)"
                : "radial-gradient(ellipse 95% 95% at 50% 52%, rgba(0,0,0,1) 40%, rgba(0,0,0,0.6) 70%, transparent 90%)",
            }}
            aria-hidden="true">
            <defs>
              <filter id="glowSoft" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="4" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
              <filter id="glowStrong" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="8" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
              <filter id="glowMed" x="-25%" y="-25%" width="150%" height="150%"><feGaussianBlur stdDeviation="5" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
            </defs>
            <g fill="none" strokeLinecap="round" strokeLinejoin="round">
              <line x1="200" y1="580" x2="1000" y2="580" strokeWidth="4" stroke="rgba(240,210,100,1)" filter="url(#glowStrong)"/>
              <line x1="180" y1="585" x2="1020" y2="585" strokeWidth="4.5" stroke="rgba(255,230,120,1)" filter="url(#glowStrong)"/>
              <line x1="220" y1="575" x2="980" y2="575" strokeWidth="1.5" stroke="rgba(201,168,76,0.9)"/>
              <line x1="350" y1="590" x2="850" y2="590" strokeWidth="1.8" stroke="rgba(201,168,76,0.8)"/>
              <line x1="370" y1="595" x2="830" y2="595" strokeWidth="1.4" stroke="rgba(201,168,76,0.65)"/>
              <line x1="390" y1="600" x2="810" y2="600" strokeWidth="1.2" stroke="rgba(201,168,76,0.5)"/>
              {[280, 410, 540, 645, 775, 900].map((x, i) => (
                <g key={`col-${i}`}>
                  <rect x={x} y="310" width="18" height="265" strokeWidth="2.5" stroke="rgba(240,210,100,1)" filter="url(#glowMed)"/>
                  <ellipse cx={x + 9} cy="310" rx="12" ry="4" strokeWidth="1.8" stroke="rgba(240,210,100,0.95)"/>
                  <rect x={x - 5} y="303" width="28" height="8" strokeWidth="1.8" stroke="rgba(240,210,100,0.95)"/>
                  <rect x={x - 5} y="570" width="28" height="8" strokeWidth="1.8" stroke="rgba(240,210,100,0.95)"/>
                </g>
              ))}
              <rect x="250" y="285" width="700" height="22" strokeWidth="2.5" stroke="rgba(240,210,100,1)" filter="url(#glowMed)"/>
              <line x1="250" y1="290" x2="950" y2="290" strokeWidth="1.2" stroke="rgba(201,168,76,0.75)"/>
              <line x1="250" y1="296" x2="950" y2="296" strokeWidth="1.2" stroke="rgba(201,168,76,0.75)"/>
              {[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14].map(i => (<rect key={`triglif-${i}`} x={270 + i * 46} y="275" width="12" height="12" strokeWidth="1.5" stroke="rgba(201,168,76,0.85)"/>))}
              <line x1="250" y1="273" x2="950" y2="273" strokeWidth="2.2" stroke="rgba(240,210,100,1)" filter="url(#glowSoft)"/>
              <path d="M250 273 L600 140 L950 273" strokeWidth="4.5" stroke="rgba(255,235,130,1)" filter="url(#glowStrong)"/>
              <path d="M270 273 L600 155 L930 273" strokeWidth="1.5" stroke="rgba(201,168,76,0.75)"/>
              <circle cx="600" cy="220" r="28" strokeWidth="2.2" stroke="rgba(240,210,100,1)" filter="url(#glowMed)"/>
              <circle cx="600" cy="220" r="18" strokeWidth="1.6" stroke="rgba(201,168,76,0.9)"/>
              <circle cx="600" cy="220" r="8" strokeWidth="1.2" stroke="rgba(201,168,76,0.7)"/>
              <path d="M560 245 Q580 225 600 245 Q620 225 640 245" strokeWidth="1.5" stroke="rgba(201,168,76,0.8)"/>
              <line x1="600" y1="140" x2="600" y2="120" strokeWidth="2.2" stroke="rgba(240,210,100,1)" filter="url(#glowSoft)"/>
              <circle cx="600" cy="115" r="7" strokeWidth="2" stroke="rgba(240,210,100,1)" filter="url(#glowMed)"/>
              <path d="M310 575 L310 400 Q365 350 420 400 L420 575" strokeWidth="2.2" stroke="rgba(240,210,100,0.95)" filter="url(#glowMed)"/>
              <path d="M440 575 L440 400 Q497 350 555 400 L555 575" strokeWidth="2.2" stroke="rgba(240,210,100,0.95)" filter="url(#glowMed)"/>
              <path d="M655 575 L655 400 Q712 350 770 400 L770 575" strokeWidth="2.2" stroke="rgba(240,210,100,0.95)" filter="url(#glowMed)"/>
              <path d="M790 575 L790 400 Q847 350 905 400 L905 575" strokeWidth="2.2" stroke="rgba(240,210,100,0.95)" filter="url(#glowMed)"/>
              <rect x="565" y="420" width="70" height="155" strokeWidth="3" stroke="rgba(255,235,130,1)" filter="url(#glowStrong)"/>
              <path d="M565 420 Q600 385 635 420" strokeWidth="2.5" stroke="rgba(240,210,100,1)" filter="url(#glowMed)"/>
              <line x1="600" y1="420" x2="600" y2="575" strokeWidth="1.2" stroke="rgba(201,168,76,0.6)"/>
              <circle cx="592" cy="500" r="3.5" strokeWidth="1.6" stroke="rgba(240,210,100,0.9)"/>
              <circle cx="608" cy="500" r="3.5" strokeWidth="1.6" stroke="rgba(240,210,100,0.9)"/>
              {[320, 450, 710, 840].map((x, i) => (
                <g key={`win-${i}`}>
                  <rect x={x} y="430" width="40" height="55" strokeWidth="2" stroke="rgba(240,210,100,0.95)" filter="url(#glowSoft)"/>
                  <line x1={x + 20} y1="430" x2={x + 20} y2="485" strokeWidth="1" stroke="rgba(201,168,76,0.6)"/>
                  <line x1={x} y1="457" x2={x + 40} y2="457" strokeWidth="1" stroke="rgba(201,168,76,0.6)"/>
                  <path d={`M${x} 430 Q${x + 20} 415 ${x + 40} 430`} strokeWidth="1.6" stroke="rgba(240,210,100,0.9)"/>
                </g>
              ))}
              {[340, 460, 710, 840].map((x, i) => (<rect key={`winh-${i}`} x={x} y="340" width="30" height="40" strokeWidth="1.4" stroke="rgba(201,168,76,0.75)"/>))}
              <line x1="230" y1="130" x2="970" y2="130" strokeWidth="1" stroke="rgba(201,168,76,0.5)" strokeDasharray="4 6"/>
              <line x1="230" y1="130" x2="230" y2="590" strokeWidth="1" stroke="rgba(201,168,76,0.45)" strokeDasharray="4 8"/>
              <line x1="970" y1="130" x2="970" y2="590" strokeWidth="1" stroke="rgba(201,168,76,0.45)" strokeDasharray="4 8"/>
              {[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17].map(i => (<line key={`bal-${i}`} x1={280 + i * 38} y1="273" x2={280 + i * 38} y2="285" strokeWidth="1.3" stroke="rgba(201,168,76,0.65)"/>))}
            </g>
          </svg>
          <div style={{
            position: "absolute", bottom: "20%", left: "50%", transform: "translateX(-50%)",
            width: isMobile ? "50%" : "30%", height: "35%",
            background: "radial-gradient(ellipse 100% 80% at 50% 80%, rgba(201,168,76,0.14) 0%, transparent 60%)",
            animation: "academiaGlow 6s ease-in-out infinite", pointerEvents: "none",
          }} />
        </div>

        <div style={{
          position: "relative", zIndex: 1, textAlign: "center",
          padding: isMobile ? "30px 20px 50px" : "60px 20px 80px",
          display: "flex", flexDirection: "column", alignItems: "center",
        }}>
          <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(8,5,2,0.75) 0%, rgba(8,5,2,0.5) 50%, transparent 80%)", pointerEvents: "none", zIndex: 0 }} />
          <span style={{ position: "relative", zIndex: 1, fontFamily: "'Cinzel', serif", fontSize: isMobile ? 8 : 9, letterSpacing: "0.5em", color: "rgba(201,168,76,0.85)", textTransform: "uppercase", display: "block", marginBottom: 16 }}>AL SOFT HOME</span>
          <h1 style={{ position: "relative", zIndex: 1, fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 36 : 52, fontWeight: 300, letterSpacing: "0.25em", textTransform: "uppercase", background: "linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", margin: "0 0 18px", lineHeight: 1.1, animation: "academiaFadeIn 1.5s ease-out both" }}>Academia</h1>
          <div style={{ position: "relative", zIndex: 1, display: "flex", justifyContent: "center", marginBottom: 18 }}>
            <div style={{ height: 1, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.4), transparent)", animation: "academiaLineReveal 2s ease-out 0.5s both" }} />
          </div>
          <p style={{ position: "relative", zIndex: 1, fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 15 : 18, fontWeight: 300, color: "rgba(240,220,170,1)", letterSpacing: "0.08em", margin: isMobile ? "0 0 40px" : "0 0 70px", padding: isMobile ? "0 10px" : 0 }}>
            Unde fiecare materie devine o aventură de neuitat
          </p>
        </div>
      </div>

      <div style={{
  width: "100%",
  maxWidth: 880,
  margin: "0 auto 30px",
  display: "flex",
  justifyContent: "center",
  gap: "12px",
  flexDirection: isMobile ? "column" : "row",
  position: "relative",
  zIndex: 1,
  padding: "0 16px"
}}>
  <button
    className="btn-primary"
    onClick={() => navigate("inscriere")}
    style={{ fontFamily: "'Cinzel', serif", width: isMobile ? "100%" : "auto" }}
  >
    Înscrie-te acum
  </button>

  <button
    className="btn-primary"
    onClick={() => window.open("/preturi.pdf", "_blank")}
    style={{ fontFamily: "'Cinzel', serif", width: isMobile ? "100%" : "auto" }}
  >
    Lista Preturi
  </button>
</div>

      <AcademiaTimeline navigate={navigate} />
    </main>
  );
}

/* ═══════════════════════════════════════════
   INSCRIERE - Page Component
   ═══════════════════════════════════════════ */

function PaginaInscriere({ navigate }) {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const [formData, setFormData] = useState({
    numeElev: "", curs: "", clasa: "",
    tipPlata: "",
    numePar: "", telefon: "", email: "",
    mesaj: "",
    metodaPlata: "",
    cardNume: "", cardNr: "", cardExp: "", cardCvv: "",
    acordDate: false,
    acordComunicari: false,
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [showTermeni, setShowTermeni] = useState(false);

  const CURS_CLASE = {
    "Robotica": ["Preșcolar", "Clasa Pregătitoare", "Clasa I", "Clasa a II-a", "Clasa a III-a", "Clasa a IV-a"],
    "Laborator experimental cu circuite electrice": ["Clasa a III-a", "Clasa a IV-a", "Clasa a V-a"],
    "Programare": ["Clasa a VI-a", "Clasa a VII-a", "Clasa a VIII-a", "Clasa a IX-a", "Clasa a X-a", "Clasa a XI-a", "Clasa a XII-a"],
    "Office for Kids": ["Clasa a III-a", "Clasa a IV-a", "Clasa a V-a", "Clasa a VI-a"],
    "Muzică populară": ["6 ani", "7 ani", "8 ani", "9 ani", "10 ani", "11 ani", "12 ani", "13 ani", "14 ani", "15 ani", "16 ani", "17 ani", "18 ani"],
    "Dezvoltare personală prin tehnici de actorie": ["Copii", "Adulți"],
  };

  const cursuri = Object.keys(CURS_CLASE);
  const claseDisponibile = formData.curs ? CURS_CLASE[formData.curs] : [];
  const claseLungi = ["Clasa a IX-a", "Clasa a X-a", "Clasa a XI-a", "Clasa a XII-a"];
  const isMuzica = formData.curs === "Muzică populară";

  const durata = formData.curs && formData.clasa
    ? (isMuzica ? "variabil, între 60 și 90"
      : ((formData.curs === "Programare" && claseLungi.includes(formData.clasa)) || formData.curs === "Dezvoltare personală prin tehnici de actorie" ? 90 : 50))
    : null;

  const getPret = (curs, clasa) => {
    if (!curs || !clasa) return null;
    if (curs === "Muzică populară") return 150;
    if (curs === "Robotica" && clasa === "Preșcolar") return 100;
    if (curs === "Robotica" && ["Clasa Pregătitoare", "Clasa I"].includes(clasa)) return 100;
    if (curs === "Robotica" && ["Clasa a II-a", "Clasa a III-a", "Clasa a IV-a"].includes(clasa)) return 140;
    if (curs === "Laborator experimental cu circuite electrice") return 150;
    if (curs === "Programare" && ["Clasa a VI-a", "Clasa a VII-a", "Clasa a VIII-a"].includes(clasa)) return 160;
    if (curs === "Programare" && claseLungi.includes(clasa)) return 200;
    if (curs === "Office for Kids") return 150;
    if (curs === "Dezvoltare personală prin tehnici de actorie") return 140;
    return null;
  };

  const pret = getPret(formData.curs, formData.clasa);
  const sedinteLuna = 4;
  const tarifLunar = pret ? pret * sedinteLuna : null;
  const discountProcent = 5;
  const areDiscountAbonament = !isMuzica;
  const tarifLunarDiscount = (tarifLunar && areDiscountAbonament) ? Math.round(tarifLunar * (1 - discountProcent / 100)) : tarifLunar;
  const economie = (tarifLunar && areDiscountAbonament) ? tarifLunar - tarifLunarDiscount : null;

  const handleChange = (field, value) => {
    if (field === "curs") setFormData(prev => ({ ...prev, curs: value, clasa: "", tipPlata: "" }));
    else setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
  };

  const validate = () => {
    const e = {};
    if (!formData.numeElev.trim()) e.numeElev = "Numele elevului este obligatoriu";
    if (!formData.curs) e.curs = "Selectați un curs";
    if (!formData.clasa) e.clasa = "Selectați clasa";
    if (!formData.numePar.trim()) e.numePar = "Numele părintelui este obligatoriu";
    if (!formData.telefon.trim()) e.telefon = "Telefonul este obligatoriu";
    else if (!/^(\+40|0)[0-9]{9}$/.test(formData.telefon.replace(/[\s\-().]/g, ""))) e.telefon = "Număr de telefon invalid";
    if (!formData.email.trim()) e.email = "Email-ul este obligatoriu";
    else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email.trim())) e.email = "Adresa de email invalidă";
    if (pret && !isMuzica && !formData.tipPlata) e.tipPlata = "Selectați tipul de plată";
    if (!formData.acordDate) e.acordDate = "Acest acord este obligatoriu pentru înscriere";
    return e;
  };

    const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length > 0) {
      setErrors(e);
      return;
    }

    try {
      const response = await fetch("https://alsofthomebackend-production.up.railway.app/api/inscriere", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        const data = await response.json();
        alert("Eroare: " + data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Nu s-a putut trimite formularul. Încearcă din nou.");
    }
  };

  const inputStyle = (field) => ({
    width: "100%", padding: "13px 16px",
    background: "rgba(240,216,152,0.05)",
    border: errors[field] ? "1px solid rgba(224,108,117,0.6)" : "1px solid rgba(240,216,152,0.22)",
    borderRadius: 6, color: "#f0d898",
    fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700,
    outline: "none", transition: "border-color 0.3s ease", boxSizing: "border-box",
  });

  const selectStyle = (field) => ({
    ...inputStyle(field),
    appearance: "none", WebkitAppearance: "none",
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2 4l4 4 4-4' fill='none' stroke='%23c9a84c' stroke-width='1.5'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat", backgroundPosition: "right 14px center",
    paddingRight: "38px", cursor: "pointer",
  });

  const labelStyle = {
    fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 700,
    letterSpacing: "0.14em", color: "#f0d898", textTransform: "uppercase",
    marginBottom: 7, display: "block",
  };

  if (submitted) {
    return (
      <main style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, position: "relative", zIndex: 3 }}>
        <ArchitecturalGrid />
        <div style={{ textAlign: "center", maxWidth: 500, padding: 40, background: "rgba(201,168,76,0.03)", border: "1px solid rgba(201,168,76,0.12)", borderRadius: 12 }}>
          <div style={{ fontSize: 48, marginBottom: 20 }}>
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="rgba(39,201,63,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 26 : 32, color: "rgba(225,200,120,0.95)", marginBottom: 16, letterSpacing: "0.1em" }}>Înscriere trimisă!</h2>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 19, color: "rgba(225,205,140,0.8)", lineHeight: 1.6, marginBottom: 30 }}>
            Vă mulțumim pentru înscriere! Veți fi contactat în curând de echipa noastră pentru confirmare și detalii suplimentare.
          </p>
          <button className="btn-primary" onClick={() => navigate("academia")} style={{ fontFamily: "'Cinzel', serif" }}>Înapoi la Academia</button>
        </div>
      </main>
    );
  }
  const amount = Math.round(Number(pret) * 100);
  const handleStripeCheckout = async () => {
  try {
    const response = await fetch("https://alsofthomebackend-production.up.railway.app/product/v1/checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: (formData.tipPlata === "abonament" ? tarifLunarDiscount * 100 : amount),
        quantity: 1,
        currency: "RON",
        name: formData.curs
      }),
    });

    // verificăm dacă status-ul HTTP e ok
    if (!response.ok) {
      const text = await response.text(); // ca să vezi exact ce a trimis serverul
      throw new Error(`HTTP error! status: ${response.status}, message: ${text}`);
    }

    const data = await response.json();

    if (data.sessionUrl) {
      window.location.href = data.sessionUrl;
    } else {
      console.error("Stripe session URL missing:", data);
      alert("A apărut o eroare la inițierea plății online.");
    }

  } catch (error) {
    console.error("Stripe checkout error:", error);
    alert("A apărut o eroare la inițierea plății online.");
  }
};

  return (
    <main style={{ minHeight: "100vh", padding: isMobile ? "100px 16px 60px" : "120px 20px 80px", position: "relative", zIndex: 3 }}>
      <ArchitecturalGrid />
      <div style={{ textAlign: "center", marginBottom: isMobile ? 30 : 50, position: "relative", zIndex: 1 }}>
        <span style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 8 : 10, letterSpacing: "0.5em", color: "#f0d898", fontWeight: 700, textTransform: "uppercase", display: "block", marginBottom: 12 }}>AL SOFT HOME</span>
        <h1 style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 32 : 46, fontWeight: 700, color: "#f0d898", letterSpacing: "0.08em", marginBottom: 16 }}>Formular de Înscriere</h1>
        <div style={{ width: 60, height: 1, background: "linear-gradient(90deg, transparent, rgba(240,216,152,0.45), transparent)", margin: "0 auto 16px" }} />
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 17 : 20, fontStyle: "italic", fontWeight: 700, color: "#f0d898", maxWidth: 500, margin: "0 auto" }}>
          Completați formularul de mai jos pentru a începe călătoria educațională.
        </p>
      </div>

      <div style={{ maxWidth: 640, margin: "0 auto", position: "relative", zIndex: 1, background: "rgba(201,168,76,0.02)", border: "1px solid rgba(201,168,76,0.08)", borderRadius: 12, padding: isMobile ? "24px 20px" : "40px 48px" }}>
        <div style={{ marginBottom: 32 }}>
          <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 16, letterSpacing: "0.18em", fontWeight: 700, color: "#f0d898", marginBottom: 20, borderBottom: "1px solid rgba(240,216,152,0.18)", paddingBottom: 10 }}>Date Elev</h3>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Nume și prenume elev *</label>
            <input type="text" value={formData.numeElev} onChange={(e) => handleChange("numeElev", e.target.value)} placeholder="ex: Popescu Maria" style={inputStyle("numeElev")} />
            {errors.numeElev && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.numeElev}</span>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16 }}>
            <div>
              <label style={labelStyle}>Curs dorit *</label>
              <select value={formData.curs} onChange={(e) => handleChange("curs", e.target.value)} style={selectStyle("curs")}>
                <option value="" style={{ background: "#1a1208", color: "rgba(240,225,165,1)" }}>-- Selectați cursul --</option>
                {cursuri.map(c => (<option key={c} value={c} style={{ background: "#1a1208", color: "rgba(240,225,165,1)" }}>{c}</option>))}
              </select>
              {errors.curs && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.curs}</span>}
            </div>
            <div>
              <label style={labelStyle}>{isMuzica ? "Vârsta *" : "Clasa / Categoria *"}</label>
              <select value={formData.clasa} onChange={(e) => handleChange("clasa", e.target.value)} disabled={!formData.curs} style={{ ...selectStyle("clasa"), opacity: formData.curs ? 1 : 0.4, cursor: formData.curs ? "pointer" : "not-allowed" }}>
                <option value="" style={{ background: "#1a1208", color: "rgba(240,225,165,1)" }}>{formData.curs ? (isMuzica ? "-- Selectați vârsta --" : "-- Selectați clasa --") : "-- Selectați mai întâi cursul --"}</option>
                {claseDisponibile.map(cl => (<option key={cl} value={cl} style={{ background: "#1a1208", color: "rgba(240,225,165,1)" }}>{cl}</option>))}
              </select>
              {errors.clasa && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.clasa}</span>}
            </div>
          </div>
          {durata && (
            <div style={{ marginTop: 16, padding: "12px 18px", background: "rgba(201,168,76,0.04)", border: "1px solid rgba(201,168,76,0.08)", borderRadius: 8, display: "flex", alignItems: "center", gap: 10 }}>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="rgba(201,168,76,0.35)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 700, color: "#f0d898" }}>Durata ședinței: <span style={{ color: "#f8ecc0" }}>{durata} min</span></span>
            </div>
          )}
        </div>

        <div style={{ marginBottom: 32 }}>
          <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 16, letterSpacing: "0.18em", fontWeight: 700, color: "#f0d898", marginBottom: 20, borderBottom: "1px solid rgba(240,216,152,0.18)", paddingBottom: 10 }}>Date Părinte / Tutore</h3>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Nume și prenume părinte *</label>
            <input type="text" value={formData.numePar} onChange={(e) => handleChange("numePar", e.target.value)} placeholder="ex: Popescu Ion" style={inputStyle("numePar")} />
            {errors.numePar && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.numePar}</span>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16 }}>
            <div>
              <label style={labelStyle}>Telefon *</label>
              <input type="tel" value={formData.telefon} onChange={(e) => handleChange("telefon", e.target.value)} placeholder="ex: 0740 123 456" style={inputStyle("telefon")} />
              {errors.telefon && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.telefon}</span>}
            </div>
            <div>
              <label style={labelStyle}>Email *</label>
              <input type="email" value={formData.email} onChange={(e) => handleChange("email", e.target.value)} placeholder="ex: email@exemplu.ro" style={inputStyle("email")} />
              {errors.email && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 12, marginTop: 4, display: "block" }}>{errors.email}</span>}
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 32 }}>
          <label style={labelStyle}>Mesaj suplimentar (opțional)</label>
          <textarea value={formData.mesaj} onChange={(e) => handleChange("mesaj", e.target.value)} placeholder="Informații suplimentare, preferințe de program, etc." rows={4} style={{ ...inputStyle("mesaj"), resize: "vertical", lineHeight: 1.5 }} />
        </div>

        {pret && !isMuzica && (
          <div style={{ marginBottom: 32 }}>
            <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 16, letterSpacing: "0.18em", fontWeight: 700, color: "#f0d898", marginBottom: 20, borderBottom: "1px solid rgba(240,216,152,0.18)", paddingBottom: 10 }}>Tip Plată</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
              {[
                { val: "ședință", label: "O singură ședință", sub: pret + " lei" },
                { val: "abonament", label: "Abonament lunar", sub: sedinteLuna + " ședințe / lună" },
              ].map(opt => {
                const sel = formData.tipPlata === opt.val;
                return (
                  <div key={opt.val} onClick={() => handleChange("tipPlata", opt.val)} style={{ padding: isMobile ? "20px 16px" : "22px 24px", background: sel ? "rgba(240,216,152,0.07)" : "rgba(240,216,152,0.02)", border: sel ? "1px solid rgba(240,216,152,0.35)" : "1px solid rgba(240,216,152,0.1)", borderRadius: 10, cursor: "pointer", transition: "all 0.3s ease", position: "relative", overflow: "hidden" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 10 }}>
                      <div style={{ width: 22, height: 22, borderRadius: "50%", border: sel ? "2px solid #f0d898" : "2px solid rgba(240,216,152,0.2)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s ease", flexShrink: 0 }}>
                        {sel && <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#f0d898" }} />}
                      </div>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 14, fontWeight: 700, letterSpacing: "0.1em", color: sel ? "#f0d898" : "rgba(240,216,152,0.5)", transition: "color 0.3s ease" }}>{opt.label}</span>
                    </div>
                    {opt.val === "abonament" && areDiscountAbonament ? (
                      <div style={{ display: "flex", alignItems: "center", gap: 12, paddingLeft: 36 }}>
                        <div style={{ position: isMobile ? "static" : "absolute", top: isMobile ? undefined : 10, right: isMobile ? undefined : 12, padding: "3px 10px", background: "rgba(39,201,63,0.12)", border: "1px solid rgba(39,201,63,0.25)", borderRadius: 4 }}>
                          <span style={{ fontFamily: "'Cinzel', serif", fontSize: 11, color: "rgba(39,201,63,0.9)", fontWeight: 700 }}>-5%</span>
                        </div>
                        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 700, color: sel ? "#f0d898" : "rgba(240,216,152,0.4)", fontStyle: "italic", transition: "color 0.3s ease" }}>{opt.sub}</span>
                      </div>
                    ) : (
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 700, color: sel ? "#f0d898" : "rgba(240,216,152,0.4)", fontStyle: "italic", transition: "color 0.3s ease", paddingLeft: 36, display: "block" }}>{opt.sub}</span>
                    )}
                  </div>
                );
              })}
            </div>
            {errors.tipPlata && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 13, fontWeight: 700, marginTop: -12, marginBottom: 16, display: "block" }}>{errors.tipPlata}</span>}

            {(formData.tipPlata || isMuzica) && (
              <div style={{ background: "rgba(240,216,152,0.04)", border: "1px solid rgba(240,216,152,0.15)", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
                  {[["Curs", formData.curs], [isMuzica ? "Vârstă" : "Clasa", formData.clasa], ["Durata", isMuzica ? `${durata} min` : `${durata} min / ședință`], ["Tarif / ședință", `${pret} lei`]].map(([k, v]) => (
                    <div key={k} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", color: "#f0d898", opacity: 0.75, textTransform: "uppercase" }}>{k}</span>
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 700, color: "#f0d898" }}>{v}</span>
                    </div>
                  ))}
                </div>
                {(formData.tipPlata === "ședință" || isMuzica) && (
                  <>
                    <div style={{ height: 1, background: "linear-gradient(to right, transparent, rgba(240,216,152,0.2), transparent)" }} />
                    <div style={{ padding: "20px 24px", background: "rgba(240,216,152,0.07)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 15, fontWeight: 700, letterSpacing: "0.2em", color: "#f0d898", textTransform: "uppercase" }}>Total</span>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 32 : 40, color: "#f0d898", fontWeight: 700, letterSpacing: "0.05em" }}>{pret} <span style={{ fontSize: 18, fontWeight: 700 }}>LEI</span></span>
                    </div>
                  </>
                )}
                {formData.tipPlata === "abonament" && (
                  <>
                    <div style={{ height: 1, background: "linear-gradient(to right, transparent, rgba(240,216,152,0.2), transparent)" }} />
                    <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: "#f0d898", opacity: 0.8 }}>Abonament lunar ({sedinteLuna} x {pret} lei)</span>
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: "#f0d898", opacity: areDiscountAbonament ? 0.5 : 1, textDecoration: areDiscountAbonament ? "line-through" : "none" }}>{tarifLunar} lei</span>
                    </div>
                    {areDiscountAbonament && (
                    <div style={{ padding: "14px 24px", background: "rgba(39,201,63,0.04)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ padding: "3px 10px", background: "rgba(39,201,63,0.12)", border: "1px solid rgba(39,201,63,0.25)", borderRadius: 4 }}>
                          <span style={{ fontFamily: "'Cinzel', serif", fontSize: 11, color: "rgba(80,220,100,0.95)", fontWeight: 700 }}>-{discountProcent}%</span>
                        </div>
                        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 700, color: "rgba(80,220,100,0.9)", fontStyle: "italic" }}>Discount aplicat</span>
                      </div>
                      <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 700, color: "rgba(80,220,100,0.95)" }}>-{economie} lei</span>
                    </div>
                    )}
                    <div style={{ height: 1, background: "linear-gradient(to right, transparent, rgba(240,216,152,0.2), transparent)" }} />
                    <div style={{ padding: "20px 24px", background: "rgba(240,216,152,0.07)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 15, fontWeight: 700, letterSpacing: "0.2em", color: "#f0d898", textTransform: "uppercase" }}>Total abonament</span>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 32 : 40, color: "#f0d898", fontWeight: 700, letterSpacing: "0.05em" }}>{tarifLunarDiscount} <span style={{ fontSize: 18, fontWeight: 700 }}>LEI</span></span>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {pret && (formData.tipPlata || isMuzica) && (
          <div style={{ marginBottom: 32 }}>
            <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 14, letterSpacing: "0.2em", fontWeight: 700, color: "#f0d898", marginBottom: 20, borderBottom: "1px solid rgba(240,216,152,0.18)", paddingBottom: 10 }}>Metodă de plată</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
              {[
                { val: "fizic", label: "Plată la sediu", sub: "Plata la sediu, prin transfer bancar", icon: "M3 10h18M3 14h18M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z" },
                { val: "online", label: "Plată online", sub: "Card bancar", icon: "M21 4H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zM1 10h22" },
              ].map(opt => {
                const sel = formData.metodaPlata === opt.val;
                return (
                  <div key={opt.val} onClick={() => handleChange("metodaPlata", opt.val)} style={{ padding: isMobile ? "20px 16px" : "22px 24px", background: sel ? "rgba(240,216,152,0.07)" : "rgba(240,216,152,0.02)", border: sel ? "1px solid rgba(240,216,152,0.35)" : "1px solid rgba(240,216,152,0.1)", borderRadius: 10, cursor: "pointer", transition: "all 0.3s ease" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 10 }}>
                      <div style={{ width: 22, height: 22, borderRadius: "50%", border: sel ? "2px solid #f0d898" : "2px solid rgba(240,216,152,0.2)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s ease", flexShrink: 0 }}>
                        {sel && <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#f0d898" }} />}
                      </div>
                      <svg viewBox="0 0 24 24" style={{ width: 20, height: 20, stroke: sel ? "#f0d898" : "rgba(240,216,152,0.3)", fill: "none", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round", transition: "stroke 0.3s ease" }}>
                        <path d={opt.icon} />
                      </svg>
                      <span style={{ fontFamily: "'Cinzel', serif", fontSize: 14, fontWeight: 700, letterSpacing: "0.1em", color: sel ? "#f0d898" : "rgba(240,216,152,0.5)", transition: "color 0.3s ease" }}>{opt.label}</span>
                    </div>
                    <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 700, color: sel ? "#f0d898" : "rgba(240,216,152,0.4)", fontStyle: "italic", transition: "color 0.3s ease", paddingLeft: 36 }}>{opt.sub}</span>
                  </div>
                );
              })}
            </div>
  {formData.metodaPlata === "online" && (
  <div style={{
    background: "rgba(201,168,76,0.03)",
    border: "1px solid rgba(201,168,76,0.1)",
    borderRadius: 10,
    padding: isMobile ? "20px 16px" : "24px 24px",
  }}>
    
    <div style={{ marginBottom: 20 }}>
      <span style={{
        fontFamily: "'Cinzel', serif",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.15em",
        color: "#f0d898",
        textTransform: "uppercase"
      }}>
        Plată online securizată
      </span>
    </div>

    <button
      onClick={handleStripeCheckout}
      style={{
        width: "100%",
        padding: "14px 40px",
        background: "linear-gradient(160deg, #f0d898, #c9a84c)",
        color: "#000",
        fontFamily: "'Cinzel', serif",
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        border: "none",
        borderRadius: 4,
        cursor: "pointer",
      }}
    >
      Plătește online
    </button>

  </div>
)}
            {formData.metodaPlata === "fizic" && (
              <div style={{ padding: "16px 20px", background: "rgba(240,216,152,0.04)", border: "1px solid rgba(240,216,152,0.12)", borderRadius: 10, display: "flex", alignItems: "center", gap: 12 }}>
                <svg viewBox="0 0 24 24" style={{ width: 20, height: 20, flexShrink: 0, stroke: "rgba(39,201,63,0.6)", fill: "none", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontWeight: 700, color: "#f0d898", lineHeight: 1.6 }}>Plata se efectuează la sediu, prin transfer bancar, înainte de fiecare ședință.</span>
              </div>
            )}
          </div>
        )}

        <div style={{ marginBottom: 32 }}>
          <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 14, letterSpacing: "0.2em", fontWeight: 700, color: "#f0d898", marginBottom: 20, borderBottom: "1px solid rgba(240,216,152,0.18)", paddingBottom: 10 }}>Termeni și condiții</h3>
          <div style={{ marginBottom: 18 }}>
            <div onClick={() => handleChange("acordDate", !formData.acordDate)} style={{ display: "flex", alignItems: "flex-start", gap: 12, cursor: "pointer", padding: "14px 16px", background: formData.acordDate ? "rgba(240,216,152,0.06)" : "transparent", border: errors.acordDate ? "1px solid rgba(224,108,117,0.35)" : formData.acordDate ? "1px solid rgba(240,216,152,0.2)" : "1px solid rgba(240,216,152,0.08)", borderRadius: 8, transition: "all 0.3s ease" }}>
              <div style={{ width: 22, height: 22, minWidth: 22, borderRadius: 4, marginTop: 2, background: formData.acordDate ? "rgba(240,216,152,0.18)" : "rgba(240,216,152,0.04)", border: errors.acordDate ? "1px solid rgba(224,108,117,0.5)" : formData.acordDate ? "1px solid #f0d898" : "1px solid rgba(240,216,152,0.15)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s ease" }}>
                {formData.acordDate && (<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#f0d898" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>)}
              </div>
              <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontWeight: 700, color: "#f0d898", lineHeight: 1.7 }}>
                Sunt de acord cu{" "}
                <span onClick={(e) => { e.stopPropagation(); setShowTermeni(true); }} style={{ color: "#f8ecc0", textDecoration: "underline", textUnderlineOffset: 3, cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.color = "#fff5b0"} onMouseLeave={(e) => e.currentTarget.style.color = "#f8ecc0"}>Termenii și condițiile</span>
                {" "}de participare la cursurile Academiei AL SOFT HOME *
              </span>
            </div>
            {errors.acordDate && <span style={{ color: "rgba(235,120,130,0.9)", fontSize: 13, fontWeight: 700, marginTop: 6, display: "block", marginLeft: 34 }}>{errors.acordDate}</span>}
          </div>
          <div>
            <div onClick={() => handleChange("acordComunicari", !formData.acordComunicari)} style={{ display: "flex", alignItems: "flex-start", gap: 12, cursor: "pointer", padding: "14px 16px", background: formData.acordComunicari ? "rgba(201,168,76,0.04)" : "transparent", border: formData.acordComunicari ? "1px solid rgba(201,168,76,0.15)" : "1px solid rgba(201,168,76,0.06)", borderRadius: 8, transition: "all 0.3s ease" }}>
              <div style={{ width: 20, height: 20, minWidth: 20, borderRadius: 4, marginTop: 2, background: formData.acordComunicari ? "rgba(201,168,76,0.2)" : "rgba(201,168,76,0.04)", border: formData.acordComunicari ? "1px solid rgba(201,168,76,0.4)" : "1px solid rgba(201,168,76,0.12)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s ease" }}>
                {formData.acordComunicari && (<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="rgba(201,168,76,0.8)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>)}
              </div>
              <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 15, fontWeight: 700, color: "#f0d898", lineHeight: 1.7 }}>Doresc să primesc informări despre cursuri noi, evenimente și oferte speciale din partea AL SOFT HOME.</span>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 16, flexDirection: isMobile ? "column" : "row" }}>
          <button className="btn-primary" onClick={handleSubmit} style={{ fontFamily: "'Cinzel', serif", flex: 1, fontWeight: 900, letterSpacing: "0.2em" }}>Trimite înscrierea</button>
          <button className="btn-secondary" onClick={() => navigate("academia")} style={{ fontFamily: "'Cinzel', serif", flex: isMobile ? 1 : "none", minWidth: 160, fontWeight: 900, letterSpacing: "0.18em" }}>Înapoi la Academia</button>
        </div>
      </div>

      {showTermeni && (
        <div onClick={() => setShowTermeni(false)} style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(8,5,2,0.88)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: isMobile ? "16px" : "32px", animation: "termFadeIn 0.25s ease" }}>
          <style>{`@keyframes termFadeIn { from { opacity:0; transform:scale(0.97); } to { opacity:1; transform:scale(1); } }`}</style>
          <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: 720, maxHeight: "88vh", background: "linear-gradient(170deg, #1a1005, #120c03)", border: "1px solid rgba(240,216,152,0.2)", borderRadius: 12, display: "flex", flexDirection: "column", boxShadow: "0 32px 80px rgba(0,0,0,0.7)", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 1, background: "linear-gradient(to right, transparent, rgba(240,216,152,0.35), transparent)" }} />
            <div style={{ padding: isMobile ? "22px 20px 16px" : "28px 36px 20px", borderBottom: "1px solid rgba(240,216,152,0.1)", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
              <div>
                <span style={{ fontFamily: "'Cinzel',serif", fontSize: 9, letterSpacing: "0.4em", color: "rgba(240,216,152,0.55)", textTransform: "uppercase", display: "block", marginBottom: 6 }}>AL SOFT HOME</span>
                <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: isMobile ? 22 : 28, fontWeight: 700, color: "#f0d898", letterSpacing: "0.08em", margin: 0 }}>Termeni și Condiții</h2>
              </div>
              <button onClick={() => setShowTermeni(false)} style={{ background: "none", border: "1px solid rgba(240,216,152,0.2)", borderRadius: 6, width: 36, height: 36, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }} onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(240,216,152,0.5)"; e.currentTarget.style.background = "rgba(240,216,152,0.07)"; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(240,216,152,0.2)"; e.currentTarget.style.background = "none"; }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#f0d898" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ overflowY: "auto", padding: isMobile ? "20px 20px 28px" : "28px 36px 36px", flex: 1, scrollbarWidth: "thin", scrollbarColor: "rgba(240,216,152,0.2) transparent" }}>
              {[
                { titlu: '1. Părțile contractante', text: 'Prezentele Termeni și Condiții reglementează relația dintre AL SOFT HOME (denumit în continuare Prestator), cu sediul în Șos. Chitilei nr. 413, Sector 1, București, și părintele/tutorele legal al elevului înscris (denumit în continuare Beneficiar).' },
                { titlu: '2. Obiectul înscrierii', text: 'Prin completarea formularului de înscriere, Beneficiarul solicită participarea elevului la cursurile organizate de AL SOFT HOME. Înscrierea devine definitivă după confirmarea scrisă sau telefonică din partea Prestatorului și achitarea tarifului aferent.' },
                { titlu: '3. Tarife și modalități de plată', text: 'Tarifele sunt cele afișate în formularul de înscriere la momentul completării acestuia. Plata se poate efectua la sediul Prestatorului, prin transfer bancar sau, acolo unde este disponibilă, prin plată online cu cardul.' },
                { titlu: '4. Anulare și reprogramare', text: 'Absențele anunțate cu minimum 24 de ore înainte pot fi recuperate într-un interval de 30 de zile, în funcție de disponibilitate. Absențele neanunțate nu sunt recuperabile.' },
                { titlu: '5. Responsabilitatea Prestatorului', text: 'AL SOFT HOME asigură un mediu sigur și supravegheat pe durata cursurilor. Prestatorul nu răspunde pentru evenimentele survenite în afara spațiului și intervalului orar al cursurilor.' },
                { titlu: '6. Prelucrarea datelor cu caracter personal (GDPR)', text: 'În conformitate cu Regulamentul (UE) 2016/679, AL SOFT HOME prelucrează datele furnizate exclusiv în scopul gestionării înscrierii și comunicării cu Beneficiarul. Datele nu vor fi transmise către terți fără consimțământul explicit al Beneficiarului.' },
                { titlu: '7. Utilizarea materialelor foto-video', text: 'Pe parcursul activităților, Prestatorul poate realiza fotografii și înregistrări video în scop documentar și promoțional. Prin bifarea acordului, Beneficiarul consimte la utilizarea imaginilor elevului în aceste materiale.' },
                { titlu: '8. Regulamentul intern', text: 'Elevii sunt așteptați să respecte regulamentul intern al AL SOFT HOME: punctualitate, respect față de colegi și instructori, grijă față de materialele didactice.' },
                { titlu: '9. Modificarea termenilor', text: 'AL SOFT HOME își rezervă dreptul de a modifica prezentele Termeni și Condiții, cu notificarea prealabilă a Beneficiarilor activi cu minimum 15 zile înainte de intrarea în vigoare a modificărilor.' },
                { titlu: '10. Legea aplicabilă', text: 'Prezentele Termeni și Condiții sunt guvernate de legislația română în vigoare. Orice litigiu va fi soluționat pe cale amiabilă.' },
              ].map((sectiune, i) => (
                <div key={i} style={{ marginBottom: 24 }}>
                  <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", color: "#f0d898", marginBottom: 10, textTransform: "uppercase" }}>{sectiune.titlu}</h3>
                  <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 16, fontWeight: 600, color: "rgba(240,216,152,0.8)", lineHeight: 1.85, letterSpacing: "0.03em", margin: 0, textAlign: "justify" }}>{sectiune.text}</p>
                </div>
              ))}
              <div style={{ marginTop: 8, padding: "16px 20px", background: "rgba(240,216,152,0.04)", border: "1px solid rgba(240,216,152,0.12)", borderRadius: 8 }}>
                <p style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 14, fontWeight: 600, color: "rgba(240,216,152,0.6)", lineHeight: 1.7, margin: 0, fontStyle: "italic" }}>Ultima actualizare: aprilie 2026. Contact: <span style={{ color: "#f0d898" }}>info@alsofthome.ro</span></p>
              </div>
            </div>
            <div style={{ padding: isMobile ? "16px 20px" : "20px 36px", borderTop: "1px solid rgba(240,216,152,0.1)", display: "flex", gap: 12, justifyContent: "flex-end", flexShrink: 0, flexWrap: "wrap" }}>
              <button onClick={() => { setShowTermeni(false); handleChange("acordDate", true); }} className="btn-primary" style={{ fontFamily: "'Cinzel',serif", fontSize: 11 }}>Am citit și sunt de acord</button>
              <button onClick={() => setShowTermeni(false)} className="btn-secondary" style={{ fontFamily: "'Cinzel',serif", fontSize: 11 }}>Închide</button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

/* ═══════════════════════════════════════════
   SOFTWARE - Clockwork Hero Animation
   ═══════════════════════════════════════════ */

function CodeBuildHero({ isMobile }) {
  const canvasRef = useRef(null);
  const animRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    const gld = (a) => `rgba(201,168,76,${a})`;
    const glt = (a) => `rgba(240,216,120,${a})`;
    const drk = (a) => `rgba(20,10,2,${a})`;

    function drawGear(cx, cy, outerR, innerR, toothH, teeth, angle, alpha, lineW) {
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(angle); ctx.globalAlpha = alpha;
      ctx.strokeStyle = glt(0.7); ctx.fillStyle = gld(0.04); ctx.lineWidth = lineW;
      const step = (Math.PI * 2) / teeth;
      ctx.beginPath();
      for (let i = 0; i < teeth; i++) {
        const a0 = i * step - step * 0.3; const a1 = i * step + step * 0.3;
        const a2 = i * step + step * 0.7; const a3 = (i + 1) * step - step * 0.3;
        ctx.lineTo(Math.cos(a0) * outerR, Math.sin(a0) * outerR);
        ctx.lineTo(Math.cos(a0) * (outerR + toothH), Math.sin(a0) * (outerR + toothH));
        ctx.lineTo(Math.cos(a1) * (outerR + toothH), Math.sin(a1) * (outerR + toothH));
        ctx.lineTo(Math.cos(a1) * outerR, Math.sin(a1) * outerR);
        ctx.lineTo(Math.cos(a2) * outerR, Math.sin(a2) * outerR);
        ctx.lineTo(Math.cos(a3) * outerR, Math.sin(a3) * outerR);
      }
      ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(0, 0, innerR, 0, Math.PI * 2); ctx.stroke();
      const spokeCount = Math.max(4, Math.floor(teeth / 4));
      for (let i = 0; i < spokeCount; i++) {
        const a = (i * Math.PI * 2) / spokeCount;
        ctx.beginPath();
        ctx.moveTo(Math.cos(a) * innerR * 0.32, Math.sin(a) * innerR * 0.32);
        ctx.lineTo(Math.cos(a) * innerR * 0.88, Math.sin(a) * innerR * 0.88);
        ctx.stroke();
      }
      ctx.beginPath(); ctx.arc(0, 0, innerR * 0.32, 0, Math.PI * 2);
      ctx.fillStyle = gld(0.12); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(0, 0, innerR * 0.12, 0, Math.PI * 2);
      ctx.fillStyle = glt(0.3); ctx.fill();
      ctx.restore();
    }

    function drawClock(cx, cy, r, handBase, frame, alpha) {
      ctx.save(); ctx.globalAlpha = alpha;
      ctx.beginPath(); ctx.arc(cx, cy, r + 5, 0, Math.PI * 2);
      ctx.fillStyle = "rgba(0,0,0,0.35)"; ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2);
      const fg = ctx.createRadialGradient(cx, cy - r * 0.1, r * 0.05, cx, cy, r);
      fg.addColorStop(0, "rgba(30,18,4,0.97)"); fg.addColorStop(0.8, "rgba(14,8,2,0.93)"); fg.addColorStop(1, "rgba(201,168,76,0.20)");
      ctx.fillStyle = fg; ctx.fill();
      ctx.strokeStyle = glt(0.65); ctx.lineWidth = 2.5; ctx.stroke();
      ctx.beginPath(); ctx.arc(cx, cy, r * 0.88, 0, Math.PI * 2);
      ctx.strokeStyle = gld(0.20); ctx.lineWidth = 0.8; ctx.stroke();
      for (let i = 0; i < 12; i++) {
        const a = (i * Math.PI * 2) / 12 - Math.PI / 2; const isQ = i % 3 === 0;
        ctx.beginPath();
        ctx.moveTo(cx + Math.cos(a) * r * (isQ ? 0.67 : 0.74), cy + Math.sin(a) * r * (isQ ? 0.67 : 0.74));
        ctx.lineTo(cx + Math.cos(a) * r * 0.85, cy + Math.sin(a) * r * 0.85);
        ctx.strokeStyle = isQ ? glt(0.80) : gld(0.35); ctx.lineWidth = isQ ? 3 : 1.2; ctx.stroke();
      }
      const ha = handBase - Math.PI / 2;
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(ha);
      ctx.beginPath(); ctx.moveTo(-r * 0.06, r * 0.08); ctx.lineTo(0, -r * 0.46); ctx.lineTo(r * 0.06, r * 0.08);
      ctx.fillStyle = glt(0.80); ctx.fill(); ctx.restore();
      const ma = ha * 12 + frame * 0.009;
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(ma);
      ctx.beginPath(); ctx.moveTo(-r * 0.04, r * 0.10); ctx.lineTo(0, -r * 0.64); ctx.lineTo(r * 0.04, r * 0.10);
      ctx.fillStyle = glt(0.60); ctx.fill(); ctx.restore();
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(frame * 0.06);
      ctx.beginPath(); ctx.moveTo(0, r * 0.22); ctx.lineTo(0, -r * 0.72);
      ctx.strokeStyle = "rgba(255,180,80,0.80)"; ctx.lineWidth = 1.2; ctx.stroke(); ctx.restore();
      ctx.beginPath(); ctx.arc(cx, cy, r * 0.06, 0, Math.PI * 2); ctx.fillStyle = glt(0.92); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy, r * 0.028, 0, Math.PI * 2); ctx.fillStyle = drk(0.9); ctx.fill();
      ctx.restore();
    }

    function drawClockLabel(cx, cy, r, label, sub, alpha) {
      ctx.save(); ctx.globalAlpha = alpha; ctx.textAlign = "center";
      const lfs = Math.max(9, Math.floor(r * 0.30));
      ctx.font = `600 ${lfs}px 'Cinzel','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.95)";
      ctx.shadowColor = "rgba(255,255,255,0.25)"; ctx.shadowBlur = 6;
      ctx.fillText(label, cx, cy + r * 0.30); ctx.shadowBlur = 0;
      const sfs = Math.max(7, Math.floor(r * 0.195));
      ctx.font = `300 italic ${sfs}px 'Cormorant Garamond','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.65)";
      ctx.fillText(sub, cx, cy + r * 0.49); ctx.restore();
    }

    function drawPendulum(frame) {
      const swing = Math.sin(frame * 0.045) * 0.28;
      const px = W * 0.5; const py = isMobile ? H * 0.260 : H * 0.185;
      const len = isMobile ? H * 0.075 : H * 0.24;
      const bx = px + Math.sin(swing) * len; const by = py + Math.cos(swing) * len;
      ctx.save();
      ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(bx, by);
      ctx.strokeStyle = gld(0.35); ctx.lineWidth = 1.5; ctx.stroke();
      const bobR = 15;
      const bg = ctx.createRadialGradient(bx - bobR * 0.3, by - bobR * 0.3, 0, bx, by, bobR);
      bg.addColorStop(0, "rgba(240,216,120,0.30)"); bg.addColorStop(1, "rgba(201,168,76,0.07)");
      ctx.beginPath(); ctx.arc(bx, by, bobR, 0, Math.PI * 2);
      ctx.fillStyle = bg; ctx.strokeStyle = glt(0.55); ctx.lineWidth = 1.5; ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(bx, by, bobR * 0.42, 0, Math.PI * 2); ctx.fillStyle = glt(0.18); ctx.fill();
      ctx.beginPath(); ctx.arc(px, py, 5, 0, Math.PI * 2); ctx.fillStyle = glt(0.5); ctx.fill();
      ctx.restore();
    }

    function drawMobileServiceList(frame, clockBottomY) {
      const alpha = Math.min(1, Math.max(0, (frame - 55) / 45));
      ctx.save(); ctx.globalAlpha = alpha; ctx.textAlign = "center";
      const services = ["WEB Design & Development", "Aplicații La Comandă", "UI / UX Interfețe"];
      const fs = Math.floor(W * 0.056); const rowH = fs * 2.4;
      const startY = clockBottomY + fs * 5.0;
      services.forEach((label, i) => {
        const y = startY + i * rowH;
        if (i > 0) {
          const lx = W * 0.15, rx = W * 0.85;
          const grad = ctx.createLinearGradient(lx, 0, rx, 0);
          grad.addColorStop(0, "rgba(201,168,76,0)"); grad.addColorStop(0.5, gld(0.22)); grad.addColorStop(1, "rgba(201,168,76,0)");
          ctx.beginPath(); ctx.moveTo(lx, y - rowH * 0.48); ctx.lineTo(rx, y - rowH * 0.48);
          ctx.strokeStyle = grad; ctx.lineWidth = 0.8; ctx.stroke();
        }
        const iconR = fs * 0.38;
        ctx.font = `500 ${fs}px 'Cinzel','Georgia',serif`;
        const textW = ctx.measureText(label).width; const gap = fs * 0.55;
        const groupW = iconR * 2 + gap + textW; const groupLeft = (W - groupW) / 2;
        const iconX = groupLeft + iconR; const textX = groupLeft + iconR * 2 + gap + textW / 2;
        const iconY = y - fs * 0.15;
        ctx.save(); ctx.translate(iconX, iconY);
        ctx.strokeStyle = gld(0.65); ctx.fillStyle = gld(0.12); ctx.lineWidth = 1.2;
        const tCount = 8; const tStep = (Math.PI * 2) / tCount;
        const oR = iconR, iR = iconR * 0.62, tH = iconR * 0.38;
        ctx.beginPath();
        for (let t = 0; t < tCount; t++) {
          const a0 = t * tStep - tStep * 0.28; const a1 = t * tStep + tStep * 0.28;
          const a2 = t * tStep + tStep * 0.72; const a3 = (t + 1) * tStep - tStep * 0.28;
          ctx.lineTo(Math.cos(a0) * oR, Math.sin(a0) * oR);
          ctx.lineTo(Math.cos(a0) * (oR + tH), Math.sin(a0) * (oR + tH));
          ctx.lineTo(Math.cos(a1) * (oR + tH), Math.sin(a1) * (oR + tH));
          ctx.lineTo(Math.cos(a1) * oR, Math.sin(a1) * oR);
          ctx.lineTo(Math.cos(a2) * oR, Math.sin(a2) * oR);
          ctx.lineTo(Math.cos(a3) * oR, Math.sin(a3) * oR);
        }
        ctx.closePath(); ctx.fill(); ctx.stroke();
        ctx.beginPath(); ctx.arc(0, 0, iR, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(0, 0, iR * 0.35, 0, Math.PI * 2); ctx.fillStyle = glt(0.35); ctx.fill();
        ctx.restore();
        ctx.font = `500 ${fs}px 'Cinzel','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.92)";
        ctx.shadowColor = "rgba(255,255,255,0.10)"; ctx.shadowBlur = 5;
        ctx.fillText(label, textX, y); ctx.shadowBlur = 0;
      });
      ctx.restore();
    }

    function drawEngravings() {
      ctx.save();
      const co = Math.min(W, H) * 0.045;
      [[0, 0, 1, 1], [W, 0, -1, 1], [0, H, 1, -1], [W, H, -1, -1]].forEach(([x, y, sx, sy]) => {
        ctx.strokeStyle = gld(0.16); ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(x + sx * co * 2, y); ctx.lineTo(x, y); ctx.lineTo(x, y + sy * co * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(x + sx * co, y + sy * co, 2, 0, Math.PI * 2); ctx.fillStyle = glt(0.25); ctx.fill();
      });
      const bg = ctx.createRadialGradient(W * 0.5, H * 0.5, 0, W * 0.5, H * 0.5, W * 0.45);
      bg.addColorStop(0, "rgba(201,168,76,0.055)"); bg.addColorStop(0.5, "rgba(201,168,76,0.018)"); bg.addColorStop(1, "rgba(201,168,76,0)");
      ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H); ctx.restore();
    }

    function drawTitle(frame) {
      const alpha = Math.min(1, frame * 0.022);
      ctx.save(); ctx.globalAlpha = alpha; ctx.textAlign = "center";
      if (isMobile) {
        const eyeFs = Math.floor(W * 0.038);
        ctx.font = `400 ${eyeFs}px 'Cinzel','Georgia',serif`; ctx.fillStyle = gld(0.55);
        ctx.fillText("AL SOFT HOME", W * 0.5, H * 0.068);
        const fs = Math.floor(W * 0.112);
        ctx.font = `300 ${fs}px 'Cormorant Garamond','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.97)";
        ctx.shadowColor = "rgba(255,255,255,0.18)"; ctx.shadowBlur = 18;
        ctx.fillText("DEZVOLTARE", W * 0.5, H * 0.140); ctx.fillText("SOFTWARE", W * 0.5, H * 0.140 + fs * 1.20);
        ctx.shadowBlur = 0;
        const ruleY = H * 0.140 + fs * 1.20 + fs * 0.60;
        const rGrad = ctx.createLinearGradient(W * 0.2, 0, W * 0.8, 0);
        rGrad.addColorStop(0, "rgba(201,168,76,0)"); rGrad.addColorStop(0.5, glt(0.35)); rGrad.addColorStop(1, "rgba(201,168,76,0)");
        ctx.beginPath(); ctx.moveTo(W * 0.2, ruleY); ctx.lineTo(W * 0.8, ruleY); ctx.strokeStyle = rGrad; ctx.lineWidth = 1; ctx.stroke();
        const sfs = Math.floor(W * 0.044);
        ctx.font = `300 italic ${sfs}px 'Cormorant Garamond','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.58)";
        ctx.fillText("cu precizie și eleganță", W * 0.5, ruleY + sfs * 1.6);
      } else {
        const eyeFs = Math.floor(W * 0.018);
        ctx.font = `400 ${eyeFs}px 'Cinzel','Georgia',serif`; ctx.fillStyle = gld(0.40);
        ctx.fillText("AL SOFT HOME", W * 0.5, H * 0.072);
        const fs = Math.floor(W * 0.040);
        ctx.font = `300 ${fs}px 'Cormorant Garamond','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.97)";
        ctx.shadowColor = "rgba(255,255,255,0.20)"; ctx.shadowBlur = 18;
        ctx.fillText("DEZVOLTARE SOFTWARE", W * 0.5, H * 0.165); ctx.shadowBlur = 0;
        const sfs = Math.floor(W * 0.022);
        ctx.font = `300 italic ${sfs}px 'Cormorant Garamond','Georgia',serif`; ctx.fillStyle = "rgba(255,255,255,0.60)";
        ctx.fillText("Soluții digitale create cu precizie și eleganță", W * 0.5, H * 0.165 + fs * 1.05);
      }
      ctx.restore();
    }

    const gears = isMobile ? [
      { cx: W * 0.500, cy: H * 0.430, outerR: W * 0.220, innerR: W * 0.126, toothH: W * 0.030, teeth: 24, speed: 0.0038, dir: 1, alpha: 0.65, lineW: 1.5 },
      { cx: W * 0.138, cy: H * 0.455, outerR: W * 0.092, innerR: W * 0.050, toothH: W * 0.013, teeth: 12, speed: 0.0085, dir: -1, alpha: 0.38, lineW: 1.0 },
      { cx: W * 0.862, cy: H * 0.455, outerR: W * 0.092, innerR: W * 0.050, toothH: W * 0.013, teeth: 12, speed: 0.0085, dir: -1, alpha: 0.38, lineW: 1.0 },
      { cx: W * 0.225, cy: H * 0.330, outerR: W * 0.048, innerR: W * 0.026, toothH: W * 0.007, teeth: 8, speed: 0.0140, dir: 1, alpha: 0.20, lineW: 0.7 },
      { cx: W * 0.775, cy: H * 0.330, outerR: W * 0.048, innerR: W * 0.026, toothH: W * 0.007, teeth: 8, speed: 0.0140, dir: 1, alpha: 0.20, lineW: 0.7 },
    ] : [
      { cx: W * 0.500, cy: H * 0.620, outerR: W * 0.125, innerR: W * 0.072, toothH: W * 0.017, teeth: 24, speed: 0.0038, dir: 1, alpha: 0.68, lineW: 1.2 },
      { cx: W * 0.185, cy: H * 0.670, outerR: W * 0.079, innerR: W * 0.044, toothH: W * 0.011, teeth: 16, speed: 0.0057, dir: -1, alpha: 0.52, lineW: 1.0 },
      { cx: W * 0.815, cy: H * 0.670, outerR: W * 0.079, innerR: W * 0.044, toothH: W * 0.011, teeth: 16, speed: 0.0057, dir: -1, alpha: 0.52, lineW: 1.0 },
      { cx: W * 0.305, cy: H * 0.490, outerR: W * 0.048, innerR: W * 0.026, toothH: W * 0.007, teeth: 10, speed: 0.0095, dir: 1, alpha: 0.32, lineW: 0.7 },
      { cx: W * 0.695, cy: H * 0.490, outerR: W * 0.048, innerR: W * 0.026, toothH: W * 0.007, teeth: 10, speed: 0.0095, dir: 1, alpha: 0.32, lineW: 0.7 },
      { cx: W * 0.500, cy: H * 0.860, outerR: W * 0.042, innerR: W * 0.022, toothH: W * 0.006, teeth: 9, speed: 0.0130, dir: -1, alpha: 0.24, lineW: 0.6 },
      { cx: W * 0.080, cy: H * 0.565, outerR: W * 0.030, innerR: W * 0.015, toothH: W * 0.004, teeth: 7, speed: 0.0180, dir: 1, alpha: 0.16, lineW: 0.5 },
      { cx: W * 0.920, cy: H * 0.565, outerR: W * 0.030, innerR: W * 0.015, toothH: W * 0.004, teeth: 7, speed: 0.0180, dir: 1, alpha: 0.16, lineW: 0.5 },
    ];

    const mobileClock = { cx: W * 0.5, cy: H * 0.430, r: W * 0.163 };
    const desktopClock = [
      { cx: W * 0.500, cy: H * 0.620, r: W * 0.092, label: "WEB", sub: "Design & Dev", hb: 1.0 },
      { cx: W * 0.185, cy: H * 0.670, r: W * 0.065, label: "Aplicații", sub: "La comandă", hb: 2.1 },
      { cx: W * 0.815, cy: H * 0.670, r: W * 0.065, label: "UI / UX", sub: "Interfețe", hb: 3.5 },
    ];

    let frame = 0;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      drawEngravings();
      if (!isMobile) {
        ctx.save();
        ctx.strokeStyle = gld(0.10); ctx.lineWidth = 0.6; ctx.setLineDash([4, 9]);
        [[0, 1], [0, 2], [0, 3], [0, 4], [1, 3], [2, 4], [0, 5], [0, 6], [0, 7]].forEach(([a, b]) => {
          if (b >= gears.length) return;
          ctx.beginPath(); ctx.moveTo(gears[a].cx, gears[a].cy); ctx.lineTo(gears[b].cx, gears[b].cy); ctx.stroke();
        });
        ctx.setLineDash([]); ctx.restore();
      }
      gears.forEach(g => drawGear(g.cx, g.cy, g.outerR, g.innerR, g.toothH, g.teeth, frame * g.speed * g.dir, g.alpha, g.lineW));
      if (isMobile) {
        const ra = Math.min(1, Math.max(0, (frame - 20) / 50));
        drawClock(mobileClock.cx, mobileClock.cy, mobileClock.r, 1.0, frame, ra);
        drawMobileServiceList(frame, mobileClock.cy + mobileClock.r);
      } else {
        desktopClock.forEach((c, i) => {
          const ra = Math.min(1, Math.max(0, (frame - i * 35) / 55));
          drawClock(c.cx, c.cy, c.r, c.hb, frame, ra);
          drawClockLabel(c.cx, c.cy, c.r, c.label, c.sub, ra);
        });
      }
      drawPendulum(frame);
      drawTitle(frame);
      frame++;
      animRef.current = requestAnimationFrame(tick);
    }

    animRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animRef.current);
  }, [isMobile]);

  return (
    <canvas ref={canvasRef} width={isMobile ? 560 : 1100} height={isMobile ? 980 : 580}
      style={{
        width: "100%", height: "auto", display: "block",
        maskImage: isMobile ? "linear-gradient(to bottom, transparent 0%, black 5%, black 93%, transparent 100%)" : "radial-gradient(ellipse 94% 90% at 50% 48%, black 35%, transparent 74%)",
        WebkitMaskImage: isMobile ? "linear-gradient(to bottom, transparent 0%, black 5%, black 93%, transparent 100%)" : "radial-gradient(ellipse 94% 90% at 50% 48%, black 35%, transparent 74%)",
      }}
    />
  );
}

/* ═══════════════════════════════════════════
   SOFTWARE - Page Component
   ═══════════════════════════════════════════ */

function PaginaSoftware({ navigate }) {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <main style={{ position: "relative", zIndex: 3, display: "flex", flexDirection: "column", alignItems: "center", padding: isMobile ? "90px 0 40px" : "110px 0 60px", width: "100%", overflowX: "hidden" }}>
      <ArchitecturalGrid />
      <div style={{ position: "relative", width: "100%", maxWidth: 1100, margin: "0 auto", marginBottom: isMobile ? 8 : 24 }}>
        <CodeBuildHero isMobile={isMobile} />
      </div>
      <div style={{ width: "100%", maxWidth: 880, margin: "0 auto 30px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1, padding: "0 16px" }}>
        <button className="btn-primary" onClick={() => navigate("contact")} style={{ fontFamily: "'Cinzel', serif", width: isMobile ? "100%" : "auto" }}>Solicită o ofertă</button>
      </div>
    </main>
  );
}

/* ═══════════════════════════════════════════
   CONTACT - Page Component
   ═══════════════════════════════════════════ */

function PaginaContact() {
  const [formData, setFormData] = useState({ nume: "", email: "", telefon: "", mesaj: "" });
  const [focusedField, setFocusedField] = useState(null);
  const [sent, setSent] = useState(false);
  const w = useWindowWidth();
  const isMobile = w < 768;

  const handleChange = (field) => (e) => setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  const handleSubmit = (e) => { e.preventDefault(); setSent(true); setTimeout(() => setSent(false), 4000); };

  const contactInfo = [
    { icon: <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>, icon2: <circle cx="12" cy="9" r="2.5"/>, label: "Sediu", value: "Șos. Chitilei, Nr. 413", sub: "Sector 1, București", href: "https://www.google.com/maps/search/?api=1&query=Soseaua+Chitilei+413+Bucuresti" },
    { icon: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>, label: "Email", value: "info@alsofthome.ro", href: "mailto:info@alsofthome.ro" },
    { icon: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.07 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/>, label: "Telefon", value: "+40 770 300 633 / +40 768 939 986", href: "tel:+40770300633" },
    { icon: <><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></>, label: "Program", value: "Luni – Vineri: 09:00 – 18:00", sub: "Sâmbătă / Duminică: 10:00 – 17:00" },
  ];

  const inputStyle = (field) => ({
    width: "100%", padding: isMobile ? "13px 16px" : "15px 20px",
    fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 17 : 18, fontWeight: 600, letterSpacing: "0.04em",
    color: "rgba(255,255,255,0.90)",
    background: focusedField === field ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.04)",
    border: focusedField === field ? "1px solid rgba(255,255,255,0.45)" : "1px solid rgba(255,255,255,0.18)",
    borderRadius: 3, outline: "none", transition: "all 0.35s ease", resize: "none",
  });

  const labelStyle = { fontFamily: "'Cinzel', serif", fontSize: 10, letterSpacing: "0.3em", color: "rgba(255,255,255,0.80)", textTransform: "uppercase", marginBottom: 8, display: "block", fontWeight: 700 };

  return (
    <main style={{ position: "relative", zIndex: 3, display: "flex", flexDirection: "column", alignItems: "center", padding: isMobile ? "90px 0 40px" : "110px 0 60px", width: "100%", overflowX: "hidden" }}>
      <ArchitecturalGrid />
      <div style={{ position: "relative", zIndex: 1, textAlign: "center", padding: isMobile ? "30px 20px 30px" : "60px 20px 50px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span style={{ fontFamily: "'Cinzel', serif", fontSize: isMobile ? 9 : 10, letterSpacing: "0.5em", color: "rgba(201,168,76,0.7)", textTransform: "uppercase", display: "block", marginBottom: 16, fontWeight: 700 }}>AL SOFT HOME</span>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 42 : 58, fontWeight: 600, letterSpacing: "0.25em", textTransform: "uppercase", background: "linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", margin: "0 0 18px", lineHeight: 1.1 }}>Contact</h1>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <div style={{ height: 1, width: 120, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.6), transparent)" }} />
        </div>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: isMobile ? 18 : 21, fontWeight: 600, color: "rgba(235,210,155,0.90)", letterSpacing: "0.06em", margin: 0, padding: isMobile ? "0 10px" : 0 }}>Ne bucurăm că sunteți parte din povestea noastră!</p>
      </div>

      <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 1060, margin: "0 auto", padding: isMobile ? "0 16px 40px" : "0 30px 50px", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr", gap: isMobile ? 28 : 40, alignItems: "start" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 12 : 16, marginBottom: isMobile ? 20 : 36 }}>
            {contactInfo.map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: isMobile ? 14 : 18, padding: isMobile ? "16px 18px" : "20px 24px", background: "linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030)", border: "1px solid rgba(180,130,40,0.5)", borderRadius: 3, transition: "transform 0.3s, box-shadow 0.3s", cursor: item.href ? "pointer" : "default", boxShadow: "0 4px 20px rgba(180,130,40,0.2)", position: "relative" }}
                onClick={() => item.href && window.open(item.href, "_blank")}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(180,130,40,0.35)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(180,130,40,0.2)"; }}
              >
                <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 1, background: "linear-gradient(to right, transparent, rgba(255,245,180,0.3), transparent)" }} />
                <div style={{ width: isMobile ? 38 : 44, height: isMobile ? 38 : 44, borderRadius: "50%", flexShrink: 0, border: "1px solid rgba(20,10,2,0.2)", background: "rgba(20,10,2,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg viewBox="0 0 24 24" style={{ width: isMobile ? 16 : 18, height: isMobile ? 16 : 18, stroke: "rgba(20,10,2,0.7)", fill: "none", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }}>{item.icon}{item.icon2}</svg>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 3, paddingTop: 2 }}>
                  <span style={{ fontFamily: "'Cinzel',serif", fontSize: 9, letterSpacing: "0.3em", color: "rgba(20,10,2,0.65)", textTransform: "uppercase", fontWeight: 700 }}>{item.label}</span>
                  <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: isMobile ? 17 : 19, fontWeight: 700, color: "rgba(20,10,2,0.95)", letterSpacing: "0.04em", lineHeight: 1.5 }}>{item.value}</span>
                  {item.sub && <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: isMobile ? 14 : 15, fontWeight: 600, fontStyle: "italic", color: "rgba(20,10,2,0.7)", letterSpacing: "0.04em" }}>{item.sub}</span>}
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "16px 24px", background: "rgba(18,10,2,0.4)", border: "1px solid rgba(201,168,76,0.08)", borderRadius: 3, flexWrap: "wrap" }}>
            <span style={{ fontFamily: "'Cinzel',serif", fontSize: 9, letterSpacing: "0.3em", color: "rgba(255,255,255,0.75)", textTransform: "uppercase", marginRight: 8, fontWeight: 700 }}>Urmărește-ne</span>
            {[
              { icon: SocialIcons.facebook, href: "https://www.facebook.com/profile.php?id=61588434437730" },
              { icon: SocialIcons.instagram, href: "https://www.instagram.com/alsofthome/" },
              { icon: SocialIcons.tiktok, href: "https://www.tiktok.com/@alsofthome" },
            ].map((s, i) => (
              <a key={i} href={s.href} target="_blank" rel="noopener noreferrer"
                style={{ width: 52, height: 52, borderRadius: "50%", border: "1px solid rgba(255,255,255,0.35)", background: "rgba(255,255,255,0.07)", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s", cursor: "pointer" }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.7)"; e.currentTarget.style.background = "rgba(255,255,255,0.15)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)"; e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
              >
                <div style={{ filter: "invert(1) brightness(1.0)", transform: "scale(1.3)" }}>{s.icon}</div>
              </a>
            ))}
          </div>
        </div>

        <div style={{ background: "rgba(18,10,2,0.6)", border: "1px solid rgba(201,168,76,0.1)", borderRadius: 3, padding: isMobile ? "28px 20px 24px" : "36px 32px 32px", position: "relative" }}>
          <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 1, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.2), transparent)" }} />
          <div style={{ fontFamily: "'Cinzel',serif", fontSize: 11, letterSpacing: "0.35em", color: "rgba(255,255,255,0.85)", textTransform: "uppercase", marginBottom: 28, textAlign: "center", fontWeight: 700 }}>Trimite-ne un mesaj</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16 }}>
              <div><label style={labelStyle}>Nume complet</label><input type="text" placeholder="Ion Popescu" value={formData.nume} onChange={handleChange("nume")} onFocus={() => setFocusedField("nume")} onBlur={() => setFocusedField(null)} style={inputStyle("nume")} /></div>
              <div><label style={labelStyle}>Email</label><input type="email" placeholder="ion@exemplu.ro" value={formData.email} onChange={handleChange("email")} onFocus={() => setFocusedField("email")} onBlur={() => setFocusedField(null)} style={inputStyle("email")} /></div>
            </div>
            <div><label style={labelStyle}>Telefon</label><input type="tel" placeholder="+40 7XX XXX XXX" value={formData.telefon} onChange={handleChange("telefon")} onFocus={() => setFocusedField("telefon")} onBlur={() => setFocusedField(null)} style={inputStyle("telefon")} /></div>
            <div><label style={labelStyle}>Mesaj</label><textarea rows={5} placeholder="Spune-ne cu ce te putem ajuta..." value={formData.mesaj} onChange={handleChange("mesaj")} onFocus={() => setFocusedField("mesaj")} onBlur={() => setFocusedField(null)} style={inputStyle("mesaj")} /></div>
            <button className="btn-primary" onClick={handleSubmit} style={{ fontFamily: "'Cinzel',serif", width: "100%", padding: "16px 40px" }}>{sent ? "✓ Mesaj trimis cu succes!" : "Trimite mesajul"}</button>
          </div>
        </div>
      </div>

      <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 1060, margin: "0 auto", padding: isMobile ? "0 16px 30px" : "0 30px 40px" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 20 : 28, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
          <div style={{ height: 1, width: 80, background: "linear-gradient(to right, transparent, rgba(201,168,76,0.4), transparent)" }} />
          <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", justifyContent: "center" }}>
            <svg viewBox="0 0 24 24" style={{ width: 20, height: 20, stroke: "rgba(255,255,255,0.75)", fill: "none", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }}><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
            <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: isMobile ? 20 : 24, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(255,255,255,0.92)" }}>Vă așteptăm la sediul nostru</span>
          </div>
          <p style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: isMobile ? 14 : 16, fontWeight: 600, fontStyle: "italic", color: "rgba(255,255,255,0.65)", letterSpacing: "0.1em" }}>Șos. Chitilei, Nr. 413, Sector 1, București</p>
        </div>
        <div style={{ position: "relative", borderRadius: 3, overflow: "hidden", border: "1px solid rgba(201,168,76,0.15)", boxShadow: "0 8px 40px rgba(0,0,0,0.4)" }}>
          <iframe title="Locația AL SOFT Home" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2847.5!2d26.0567!3d44.4897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zU29zZWF1YSBDaGl0aWxlaSA0MTMsIEJ1Y3VyZXN0aQ!5e0!3m2!1sro!2sro!4v1700000000000"
            width="100%" height={isMobile ? "280" : "420"} style={{ border: 0, display: "block", filter: "saturate(0.15) brightness(0.55) contrast(1.3) sepia(0.35)", transition: "filter 0.5s ease" }}
            allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            onMouseEnter={(e) => { e.currentTarget.style.filter = "saturate(0.3) brightness(0.65) contrast(1.2) sepia(0.2)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.filter = "saturate(0.15) brightness(0.55) contrast(1.3) sepia(0.35)"; }}
          />
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 60, background: "linear-gradient(to top, rgba(14,8,2,0.6), transparent)", pointerEvents: "none", zIndex: 1 }} />
        </div>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <a href="https://www.google.com/maps/search/?api=1&query=Soseaua+Chitilei+413+Bucuresti" target="_blank" rel="noopener noreferrer"
            style={{ fontFamily: "'Cinzel',serif", fontSize: 10, letterSpacing: "0.2em", color: "rgba(255,255,255,0.75)", textTransform: "uppercase", textDecoration: "none", padding: "10px 24px", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 2, transition: "all 0.3s", display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700 }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.75)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)"; }}
          >
            <svg viewBox="0 0 24 24" style={{ width: 13, height: 13, stroke: "currentColor", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }}><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/></svg>
            Deschide în Google Maps
          </a>
        </div>
      </div>
    </main>
  );
}

/* ═══════════════════════════════════════════
   HAMBURGER MENU COMPONENT
   ═══════════════════════════════════════════ */

function HamburgerIcon({ open, onClick, scrolled }) {
  const barColor = scrolled ? "#f0d898" : "rgba(20,10,2,0.75)";
  return (
    <button onClick={onClick} aria-label={open ? "Închide meniul" : "Deschide meniul"}
      style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: 36, height: 36, background: "none", border: "none", cursor: "pointer", gap: 5, padding: 4 }}>
      <span style={{ display: "block", width: 22, height: 1.5, background: barColor, borderRadius: 1, transition: "all 0.3s ease", transform: open ? "translateY(6.5px) rotate(45deg)" : "none" }} />
      <span style={{ display: "block", width: 22, height: 1.5, background: barColor, borderRadius: 1, transition: "all 0.3s ease", opacity: open ? 0 : 1 }} />
      <span style={{ display: "block", width: 22, height: 1.5, background: barColor, borderRadius: 1, transition: "all 0.3s ease", transform: open ? "translateY(-6.5px) rotate(-45deg)" : "none" }} />
    </button>
  );
}

/* ═══════════════════════════════════════════
   MAIN APP
   ═══════════════════════════════════════════ */

export default function App() {
  const getPageFromHash = () => {
    const hash = window.location.hash.replace("#", "");
    if (hash === "inscriere") return "inscriere";
    if (NAV_LINKS.find(l => l.key === hash)) return hash;
    return "acasa";
  };

  const [page, setPage] = useState(getPageFromHash);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const w = useWindowWidth();
  const isMobile = w < 900;
  const isSmall = w < 768;

  const navigate = (key) => { window.location.hash = key; setMenuOpen(false); window.scrollTo(0, 0); };

  useEffect(() => {
    const onHashChange = () => setPage(getPageFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [page]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => { if (!e.target.closest(".mobile-menu-panel") && !e.target.closest(".hamburger-btn")) setMenuOpen(false); };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [menuOpen]);

  useEffect(() => { document.body.style.overflow = menuOpen ? "hidden" : ""; return () => { document.body.style.overflow = ""; }; }, [menuOpen]);

  useEffect(() => {
    const existing = document.getElementById("alsoft-global-styles");
    if (existing) existing.remove();
    const style = document.createElement("style");
    style.id = "alsoft-global-styles";
    style.innerHTML = `
      @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Cinzel:wght@400;500;700&family=Nunito:wght@700;800&display=swap');
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      html { scroll-behavior: smooth; }
      body { font-family: 'Nunito', sans-serif; background: #0e0802; color: #c9a84c; overflow-x: hidden; }
      .bg { position: fixed; inset: 0; z-index: 0; background: #0e0802; background-image: radial-gradient(ellipse 70% 60% at 0% 0%, #9e9962 0%, transparent 60%), radial-gradient(ellipse 60% 50% at 100% 100%, #181008 0%, transparent 60%); }
      .particle { position: fixed; border-radius: 50%; pointer-events: none; z-index: 2; background: rgba(201,168,76,0.55); animation: floatUp linear infinite; }
      @keyframes floatUp { 0% { transform: translateY(100vh); opacity: 0; } 10% { opacity: 0.7; } 90% { opacity: 0.2; } 100% { transform: translateY(-80px); opacity: 0; } }
      nav { position: fixed; top: 12px; left: 50%; transform: translateX(-50%); width: 92%; max-width: 1200px; z-index: 100; display: flex; align-items: center; justify-content: space-between; padding: 12px 24px; background: linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030); border: 1px solid rgba(180,130,40,0.5); border-radius: 16px; box-shadow: 0 8px 32px rgba(180,130,40,0.25); }
      @media (min-width: 900px) { nav { padding: 14px 32px; top: 20px; } }
      .nav-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; }
      .nav-logo-text { display: flex; flex-direction: column; gap: 1px; }
      .nav-logo-sub { font-family: 'Cinzel', serif; font-size: 7px; letter-spacing: 0.4em; color: #000; text-transform: uppercase; transition: color 0.4s ease; }
      .nav-logo-name { font-family: 'Cormorant Garamond', serif; font-size: 18px; letter-spacing: 0.18em; color: #000; text-transform: uppercase; line-height: 1.1; font-weight: 700; transition: color 0.4s ease; }
      .nav-links { display: flex; align-items: center; gap: 2px; list-style: none; }
      .nav-links a { text-decoration: none; font-size: 11px; font-weight: 800; color: #000; letter-spacing: 0.1em; text-transform: uppercase; padding: 8px 13px; border-radius: 2px; transition: color 0.2s ease; position: relative; }
      .nav-links a:hover { color: #000; opacity: 0.7; }
      .nav-links a.activ { color: #000; }
      .nav-links a.activ::after { content: ''; position: absolute; bottom: 3px; left: 13px; right: 13px; height: 1.5px; background: linear-gradient(to right, transparent, #000, transparent); }
      .nav-right { display: flex; align-items: center; gap: 14px; }
      .nav-social { display: flex; align-items: center; cursor: pointer; transition: opacity 0.2s, color 0.4s ease; opacity: 1; color: #000; text-decoration: none; }
      .nav-social:hover { opacity: 0.65; }
      .nav-lang { font-size: 10px; letter-spacing: 0.12em; color: #000; font-weight: 800; transition: color 0.4s ease; }
      .nav-divider { width: 1px; height: 18px; background: rgba(0,0,0,0.35); transition: background 0.4s ease; }
      nav.scrolled .nav-logo-sub { color: rgba(201,168,76,0.7); }
      nav.scrolled .nav-logo-name { color: rgba(240,220,160,1); }
      nav.scrolled .nav-links a { color: #f0d898; }
      nav.scrolled .nav-links a:hover { color: #f8ecc0; }
      nav.scrolled .nav-links a.activ { color: #f8ecc0; font-weight: 900; }
      nav.scrolled .nav-links a.activ::after { background: linear-gradient(to right, transparent, rgba(240,216,152,0.55), transparent); }
      nav.scrolled .nav-social { color: #f0d898; }
      nav.scrolled .nav-lang { color: #f0d898; }
      nav.scrolled .nav-divider { background: rgba(240,216,152,0.3); }
      .mobile-menu-overlay { position: fixed; inset: 0; z-index: 99; background: rgba(14,8,2,0.6); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); opacity: 0; pointer-events: none; transition: opacity 0.35s ease; }
      .mobile-menu-overlay.open { opacity: 1; pointer-events: auto; }
      .mobile-menu-panel { position: fixed; top: 0; right: 0; width: min(320px, 85vw); height: 100vh; height: 100dvh; z-index: 101; background: linear-gradient(180deg, #c9a050, #b08030); box-shadow: -8px 0 40px rgba(0,0,0,0.5); transform: translateX(100%); transition: transform 0.4s cubic-bezier(0.32,0.72,0,1); display: flex; flex-direction: column; padding: 80px 32px 40px; overflow-y: auto; }
      .mobile-menu-panel.open { transform: translateX(0); }
      .mobile-menu-panel a { text-decoration: none; font-family: 'Cormorant Garamond', serif; font-size: 22px; font-weight: 800; letter-spacing: 0.12em; color: #000; text-transform: uppercase; padding: 16px 0; border-bottom: 1px solid rgba(0,0,0,0.15); display: block; transition: color 0.2s; }
      .mobile-menu-panel a:first-child { border-top: 1px solid rgba(0,0,0,0.15); }
      .mobile-menu-socials { display: flex; gap: 16px; margin-top: auto; padding-top: 30px; }
      .hero { position: relative; z-index: 3; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; text-align: center; padding: 120px 40px 60px; }
      @media (max-width: 767px) { .hero { padding: 90px 20px 40px; } }
      .hero-desc { font-family: 'Cormorant Garamond', serif; font-size: 19px; font-weight: 300; line-height: 1.9; color: rgba(210,185,140,0.6); max-width: 520px; margin-bottom: 14px; letter-spacing: 0.06em; }
      @media (max-width: 767px) { .hero-desc { font-size: 16px; line-height: 1.7; max-width: 100%; } }
      .hero-sub { font-family: 'Cormorant Garamond', serif; font-size: 14px; font-style: italic; font-weight: 300; color: rgba(201,168,76,0.35); letter-spacing: 0.25em; margin-bottom: 40px; }
      @media (max-width: 767px) { .hero-sub { font-size: 12px; letter-spacing: 0.15em; margin-bottom: 28px; } }
      .services-grid { display: flex; gap: 20px; flex-wrap: wrap; justify-content: center; margin-bottom: 32px; }
      @media (max-width: 767px) { .services-grid { flex-direction: column; align-items: stretch; gap: 14px; padding: 0 4px; margin-bottom: 24px; } }
      .service-card { display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 36px 56px; width: 340px; background: linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030); border: 1px solid rgba(180,130,40,0.5); border-radius: 3px; cursor: pointer; position: relative; transition: background 0.45s ease, border-color 0.45s ease, transform 0.3s, box-shadow 0.45s ease; box-shadow: 0 8px 32px rgba(180,130,40,0.3); }
      @media (max-width: 767px) { .service-card { width: 100%; padding: 24px 20px; gap: 10px; } }
      .service-card::before { content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px; background: linear-gradient(to right, transparent, rgba(20,10,2,0.15), transparent); transition: left 0.3s, right 0.3s, background 0.45s; }
      .service-card:hover { background: rgba(18,10,2,0.88); border-color: rgba(201,168,76,0.22); transform: translateY(-5px); box-shadow: 0 12px 48px rgba(201,168,76,0.18); }
      .service-card:hover::before { left: 25%; right: 25%; background: linear-gradient(to right, transparent, rgba(201,168,76,0.32), transparent); }
      .service-icon { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(20,10,2,0.2); border-radius: 50%; background: rgba(20,10,2,0.08); transition: border-color 0.45s ease, background 0.45s ease; }
      .service-card:hover .service-icon { border-color: rgba(201,168,76,0.35); background: rgba(201,168,76,0.08); }
      .service-icon svg { width: 20px; height: 20px; stroke: rgba(20,10,2,0.8); fill: none; stroke-width: 1.4; stroke-linecap: round; stroke-linejoin: round; transition: stroke 0.45s ease; }
      .service-card:hover .service-icon svg { stroke: #c9a84c; }
      .service-name { font-family: 'Cormorant Garamond', serif; font-size: 15px; letter-spacing: 0.18em; text-transform: uppercase; text-align: center; background: none; -webkit-text-fill-color: rgba(20,10,2,0.85); transition: all 0.45s ease; }
      .service-card:hover .service-name { background: linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
      .service-desc { font-family: 'Cormorant Garamond', serif; font-size: 12px; font-style: italic; font-weight: 300; color: rgba(20,10,2,0.55); letter-spacing: 0.08em; text-align: center; line-height: 1.6; transition: color 0.45s ease; }
      .service-card:hover .service-desc { color: rgba(201,168,76,0.5); }
      @media (max-width: 767px) { .cta-row { flex-direction: column; gap: 10px; width: 100%; padding: 0 4px; margin-bottom: 32px; } }
      .btn-primary { padding: 14px 40px; background: linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030); color: #140e06; font-size: 11px; font-weight: 800; letter-spacing: 0.15em; text-transform: uppercase; border: none; border-radius: 2px; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; box-shadow: 0 4px 20px rgba(201,168,76,0.25); }
      .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(201,168,76,0.35); }
      @media (max-width: 767px) { .btn-primary { width: 100%; padding: 16px 20px; font-size: 11px; } }
      .btn-secondary { padding: 14px 32px; background: transparent; color: rgba(201,168,76,0.55); font-size: 11px; font-weight: 700; letter-spacing: 0.15em; text-transform: uppercase; border: 1px solid rgba(201,168,76,0.22); border-radius: 2px; cursor: pointer; transition: border-color 0.2s, color 0.2s; }
      .btn-secondary:hover { border-color: rgba(201,168,76,0.45); color: #c9a84c; }
      @media (max-width: 767px) { .btn-secondary { width: 100%; padding: 14px 20px; } }
      footer { position: relative; z-index: 3; padding: 0; }
      .footer-bar { background: linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030); border-top: 1px solid rgba(255,230,130,0.35); box-shadow: 0 -4px 24px rgba(180,130,40,0.2); overflow: hidden; }
      .footer-bar::before { content: ''; display: block; height: 1px; background: linear-gradient(to right, transparent, rgba(255,245,180,0.55), transparent); }
      .footer-inner { width: 100%; padding: 18px 32px 12px; display: flex; flex-direction: column; gap: 20px; }
      @media (max-width: 767px) { .footer-inner { padding: 16px 16px 12px; gap: 16px; } }
      .footer-cols { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 0; align-items: center; }
      @media (max-width: 767px) { .footer-cols { grid-template-columns: 1fr; gap: 16px; } }
      .footer-col { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; padding: 0 32px; border-right: 1px solid rgba(20,10,2,0.1); text-align: center; }
      @media (max-width: 767px) { .footer-col { padding: 0; border-right: none; border-bottom: 1px solid rgba(20,10,2,0.08); padding-bottom: 14px; } .footer-col:last-child { border-bottom: none; padding-bottom: 0; } }
      .footer-col:first-child { padding-left: 0; }
      .footer-col:last-child { padding-right: 0; border-right: none; }
      .footer-item { display: flex; align-items: flex-start; justify-content: center; gap: 8px; }
      .footer-item svg { width: 14px; height: 14px; stroke: rgba(20,10,2,0.45); fill: none; stroke-width: 1.5; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; margin-top: 2px; }
      .footer-item span, .footer-item a { font-size: 13px; color: rgba(20,10,2,0.65); line-height: 1.4; letter-spacing: 0.02em; text-decoration: none; transition: color 0.2s; }
      .footer-item a:hover { color: rgba(20,10,2,0.9); }
      .footer-divider { height: 1px; background: linear-gradient(to right, transparent, rgba(20,10,2,0.1), transparent); }
      .footer-bottom { display: flex; align-items: center; justify-content: center; padding-bottom: 2px; }
      .footer-copy { font-size: 9px; color: rgba(20,10,2,0.28); letter-spacing: 0.08em; text-align: center; }
      .wip-page { position: relative; z-index: 3; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: calc(100vh - 120px); padding: 140px 40px 60px; text-align: center; }
      @media (max-width: 767px) { .wip-page { padding: 100px 20px 40px; } }
      .wip-icon { width: 60px; height: 60px; margin-bottom: 28px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(201,168,76,0.2); border-radius: 50%; }
      .wip-icon svg { width: 28px; height: 28px; stroke: rgba(201,168,76,0.4); fill: none; stroke-width: 1.4; stroke-linecap: round; stroke-linejoin: round; }
      .wip-title { font-family: 'Cormorant Garamond', serif; font-size: 28px; font-weight: 300; letter-spacing: 0.15em; text-transform: uppercase; background: linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; margin-bottom: 14px; }
      .wip-sub { font-family: 'Cormorant Garamond', serif; font-size: 15px; font-style: italic; font-weight: 300; color: rgba(201,168,76,0.35); letter-spacing: 0.12em; }
      /* ── DESPRE NOI ─────────────────────────────────── */
      .despre-page { position: relative; z-index: 3; isolation: isolate; min-height: calc(100vh - 120px); display: flex; align-items: center; justify-content: center; padding: 120px 60px 80px; }
      @media (max-width: 900px) { .despre-page { padding: 100px 28px 60px; } }
      .despre-inner { position: relative; z-index: 2; width: 100%; max-width: 1180px; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; }
      @media (max-width: 900px) { .despre-inner { grid-template-columns: 1fr; gap: 48px; } }
      .despre-text { display: flex; flex-direction: column; gap: 0; }
      .despre-eyebrow { font-family: 'Cormorant Garamond', serif; font-size: 11px; font-weight: 700; letter-spacing: 0.30em; text-transform: uppercase; color: rgba(201,168,76,0.55); margin: 0 0 14px; }
      .despre-titlu { font-family: 'Cormorant Garamond', serif; font-size: clamp(34px, 4vw, 54px); font-weight: 300; letter-spacing: 0.12em; text-transform: uppercase; background: linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; margin: 0 0 20px; line-height: 1.15; }
      .despre-linie { width: 60px; height: 1px; background: linear-gradient(to right, rgba(201,168,76,0.7), transparent); margin-bottom: 28px; }
      .despre-paragraf { font-family: 'Cormorant Garamond', serif; font-size: clamp(15px, 1.4vw, 17px); font-weight: 400; line-height: 1.85; color: rgba(220,195,130,0.72); margin: 0 0 18px; letter-spacing: 0.02em; }
      .despre-values { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 12px; }
      .despre-tag { font-family: 'Cormorant Garamond', serif; font-size: 11px; font-weight: 700; letter-spacing: 0.20em; text-transform: uppercase; color: rgba(201,168,76,0.65); border: 1px solid rgba(201,168,76,0.22); border-radius: 2px; padding: 6px 14px; transition: border-color 0.25s, color 0.25s; cursor: default; }
      .despre-tag:hover { border-color: rgba(201,168,76,0.5); color: #c9a84c; }
      .despre-img-wrap { position: relative; }
      .despre-img-frame { position: relative; width: 100%; padding-top: 115%; border-radius: 3px; overflow: hidden; border: 1px solid rgba(201,168,76,0.22); box-shadow: 0 24px 64px rgba(0,0,0,0.45), 0 0 0 1px rgba(201,168,76,0.08); }
      @media (max-width: 900px) { .despre-img-frame { padding-top: 66%; } }
      .despre-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; filter: brightness(0.88) saturate(0.95); transition: transform 0.6s ease, filter 0.5s ease; }
      .despre-img-frame:hover .despre-img { transform: scale(1.03); filter: brightness(0.96) saturate(1.05); }
      .despre-img-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(14,8,2,0.55) 0%, rgba(14,8,2,0.1) 40%, transparent 70%); pointer-events: none; }
      .despre-img-deco { position: absolute; bottom: -14px; right: -14px; width: 120px; height: 120px; border: 1px solid rgba(201,168,76,0.18); border-radius: 3px; pointer-events: none; z-index: -1; }
      @media (max-width: 900px) { .despre-img-deco { display: none; } }
      @keyframes academiaFadeIn { 0% { opacity: 0; transform: scale(1.04) translateY(10px); } 100% { opacity: 1; transform: scale(1) translateY(0); } }
      @keyframes academiaGlow { 0%, 100% { opacity: 0.4; } 50% { opacity: 0.7; } }
      @keyframes academiaLineReveal { 0% { width: 0; opacity: 0; } 100% { width: 120px; opacity: 1; } }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <>
      <div className="bg" />
      {PARTICLES.map((p, i) => (
        <div key={i} className="particle" style={{ left: p.left, width: p.size, height: p.size, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }} />
      ))}

      <nav className={scrolled ? "scrolled" : ""} style={{
        background: scrolled ? "rgba(28,18,6,0.88)" : "linear-gradient(160deg, #c9a050, #dbb860, #c09040, #b08030)",
        borderColor: scrolled ? "rgba(201,168,76,0.18)" : "rgba(180,130,40,0.5)",
        boxShadow: scrolled ? "0 8px 32px rgba(0,0,0,0.45)" : "0 8px 32px rgba(180,130,40,0.25)",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(12px)" : "none",
        transition: "background 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease",
      }}>
        <a href="#acasa" className="nav-logo" onClick={(e) => { e.preventDefault(); navigate("acasa"); }}>
          <img src={logoImg} alt="Logo" style={{ height: isSmall ? 32 : 40, width: "auto", filter: scrolled ? "brightness(0) saturate(100%) invert(72%) sepia(55%) saturate(400%) hue-rotate(5deg) brightness(105%)" : "none", transition: "filter 0.4s ease" }} />
          <div className="nav-logo-text">
            <span className="nav-logo-sub" style={{ color: scrolled ? "rgba(201,168,76,0.7)" : "#000", fontWeight: 700 }}>AL SOFT</span>
            <span className="nav-logo-name" style={{ color: scrolled ? "rgba(240,220,160,1)" : "#000", fontWeight: 700 }}>Home</span>
          </div>
        </a>

        {!isMobile && (
          <ul className="nav-links">
            {NAV_LINKS.map((link) => (
              <li key={link.key}>
                <button
    className={page === link.key ? "activ" : ""}
    onClick={() => navigate(link.key)}
    style={{
      color: scrolled ? (page === link.key ? "#f8ecc0" : "#f0d898") : "#000",
      fontWeight: page === link.key ? 900 : 800,
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: 0,
      font: "inherit",
    }}
  >
    {link.label}
  </button>
              </li>
            ))}
          </ul>
        )}

        {!isMobile && (
          <div className="nav-right">
            <a href="https://www.facebook.com/profile.php?id=61588434437730" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: scrolled ? "#f0d898" : "#000" }}>{SocialIcons.facebook}</a>
            <a href="https://www.instagram.com/alsofthome/" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: scrolled ? "#f0d898" : "#000" }}>{SocialIcons.instagram}</a>
            <a href="https://www.tiktok.com/@alsofthome" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: scrolled ? "#f0d898" : "#000" }}>{SocialIcons.tiktok}</a>
            <div className="nav-divider" style={{ background: scrolled ? "rgba(240,216,152,0.3)" : "rgba(0,0,0,0.3)" }} />
            <span className="nav-lang" style={{ color: scrolled ? "#f0d898" : "#000", fontWeight: 800 }}>RO</span>
          </div>
        )}

        {isMobile && (
          <div className="hamburger-btn">
            <HamburgerIcon open={menuOpen} onClick={() => setMenuOpen(!menuOpen)} scrolled={scrolled} />
          </div>
        )}
      </nav>

      {isMobile && (
        <>
          <div className={`mobile-menu-overlay ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(false)} />
          <div className={`mobile-menu-panel ${menuOpen ? "open" : ""}`}>
            {NAV_LINKS.map((link) => (
             <a
  key={link.key}
  href={`/${link.key}`}  // URL valid
  className={page === link.key ? "activ" : ""}
  onClick={(e) => {
    e.preventDefault();  // încă folosești SPA navigation
    navigate(link.key);
  }}
  style={{
    textDecoration: "none",
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.12em",
    color: "#000",
    textTransform: "uppercase",
    padding: "16px 0",
    borderBottom: "1px solid rgba(0,0,0,0.2)",
    display: "block",
  }}
>
  {link.label}
</a>
            ))}
            <div className="mobile-menu-socials">
              <a href="https://www.facebook.com/profile.php?id=61588434437730" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: "#000" }}>{SocialIcons.facebook}</a>
              <a href="https://www.instagram.com/alsofthome/" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: "#000" }}>{SocialIcons.instagram}</a>
              <a href="https://www.tiktok.com/@alsofthome" target="_blank" rel="noopener noreferrer" className="nav-social" style={{ color: "#000" }}>{SocialIcons.tiktok}</a>
            </div>
          </div>
        </>
      )}

      {page === "acasa" ? (
        <main className={`hero${scrolled ? " scrolled" : ""}`}>
          <ArchitecturalGrid />
          <p className="hero-desc" style={{ fontWeight: 600, color: "rgba(235,210,155,0.90)", fontSize: isMobile ? 17 : 21 }}>
            Trei servicii de excepție, o singură viziune —<br />calitate, profesionalism și atenție la fiecare detaliu.
          </p>
          <p className="hero-sub" style={{ fontWeight: 600, color: "rgba(201,168,76,0.75)", fontSize: isMobile ? 13 : 15 }}>Educație &nbsp;·&nbsp; Web Development &nbsp;·&nbsp; Curățenie</p>

          <div className="services-grid">
            {[
              { name: ["AL SOFT", "Academia"], desc: ["Robotică · Laborator Experimental", "Programare · Office for Kids", "Muzică Populară · Dezvoltare Personală", "prin Tehnici de Actorie"], icon: <path d="M3 21h18M3 12h18M3 9l9-4 9 4M5 12v9M19 12v9M9 12v9M15 12v9" />, navKey: "academia" },
              { name: ["Creare", "de Site-uri și Aplicații"], desc: ["Web design &", "Development"], icon: <><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4M7 8l3 3-3 3M13 14h4" /></>, navKey: "software" },
              { name: ["Curățenie", "Profesională"], desc: ["Servicii complete", "pentru casa ta"], icon: <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />, navKey: "curatenie" },
            ].map(({ name, desc, icon, navKey }) => (
              <div key={name[0]} className={`service-card${scrolled && isSmall ? " scrolled" : ""}`} onClick={() => navigate(navKey)}>
                <div className="service-icon"><svg viewBox="0 0 24 24">{icon}</svg></div>
                <div className="service-name" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 800, letterSpacing: "0.18em", textTransform: "uppercase", textAlign: "center" }}>{name[0]}<br />{name[1]}</div>
                <div className="service-desc" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 14, fontStyle: "italic", fontWeight: 600, letterSpacing: "0.08em", textAlign: "center", lineHeight: 1.6 }}>{desc.map((line, i) => <span key={i}>{line}{i < desc.length - 1 && <br />}</span>)}</div>
              </div>
            ))}
          </div>

          <div className="cta-row">
            <button className="btn-primary" onClick={() => navigate("despre")}>Descoperă informații despre noi!</button>
            <button className="btn-secondary" onClick={() => navigate("contact")}>Contactează-ne</button>
          </div>
        </main>

      ) : page === "academia" ? (
        <PaginaAcademia navigate={navigate} />
      ) : page === "inscriere" ? (
        <PaginaInscriere navigate={navigate} />
      ) : page === "software" ? (
        <PaginaSoftware navigate={navigate} />
      ) : page === "contact" ? (
        <PaginaContact />
      ) : page === "despre" ? (
        <div style={{ position: "relative", zIndex: 3, minHeight: "calc(100vh - 120px)", display: "flex", alignItems: "center", justifyContent: "center", padding: isMobile ? "100px 28px 60px" : "120px 60px 80px" }}>
          <div style={{ position: "relative", zIndex: 2, width: "100%", maxWidth: 1180, display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 48 : 72, alignItems: "center" }}>
            {/* ── Coloana stânga: text ── */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.30em", textTransform: "uppercase", color: "rgba(201,168,76,0.55)", margin: "0 0 14px" }}>Cine suntem?</p>
              <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(34px, 4vw, 54px)", fontWeight: 300, letterSpacing: "0.12em", textTransform: "uppercase", background: "linear-gradient(135deg, #8a6820, #c9a050, #f0d878, #c9a050, #8a6820)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", margin: "0 0 20px", lineHeight: 1.15 }}>AL SOFT HOME</h1>
              <div style={{ width: 60, height: 1, background: "linear-gradient(to right, rgba(201,168,76,0.7), transparent)", marginBottom: 28 }} />
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 400, lineHeight: 1.85, color: "rgba(220,195,130,0.72)", margin: "0 0 18px", letterSpacing: "0.02em", textAlign: "justify" }}>
                AL SOFT HOME este mai mult decât o companie — este o viziune.
                Ne-am construit misiunea în jurul a doi piloni esențiali: educație de calitate
                prin AL SOFT Academia și dezvoltare digitală prin servicii de creare de site-uri
                și aplicații web.
              </p>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 400, lineHeight: 1.85, color: "rgba(220,195,130,0.72)", margin: "0 0 18px", letterSpacing: "0.02em", textAlign: "justify" }}>
                Suntem absolvenți ai Facultății de Automatică și Calculatoare și am continuat
                această formare la nivel de masterat în cadrul aceleiași facultăți, fapt care ne-a permis să îmbinăm rigoarea tehnică
                cu o abordare educațională autentică și bine fundamentată.
              </p>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 400, lineHeight: 1.85, color: "rgba(220,195,130,0.72)", margin: "0 0 18px", letterSpacing: "0.02em", textAlign: "justify" }}>
                Credem că excelența ia ființă din atenție la detalii și dintr-o echipă dedicată
                care plasează oamenii în centrul fiecărui proiect. Fiecare serviciu pe care îl oferim
                este proiectat astfel încât să aducă valoare reală în viața celor cu care lucrăm.
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
                {["Educație", "Perseverență", "Inovație", "Dedicare"].map((v) => (
                  <span key={v} style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.20em", textTransform: "uppercase", color: "rgba(201,168,76,0.65)", border: "1px solid rgba(201,168,76,0.22)", borderRadius: 2, padding: "6px 14px" }}>{v}</span>
                ))}
              </div>
            </div>

            {/* ── Coloana dreapta: imagine ── */}
            <div style={{ position: "relative" }}>
              <div style={{
                width: "100%",
                height: isMobile ? 320 : 520,
                borderRadius: 3,
                overflow: "hidden",
                border: "1px solid rgba(201,168,76,0.22)",
                boxShadow: "0 24px 64px rgba(0,0,0,0.45)",
                position: "relative",
              }}>
                <img
                  src={imgDespreNoi}
                  alt="Despre AL SOFT HOME"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center top",
                    display: "block",
                    filter: "brightness(0.88) saturate(0.95)",
                  }}
                />
                {/* gradient auriu elegant la bază */}
                <div style={{
                  position: "absolute", bottom: 0, left: 0, right: 0,
                  height: "48%",
                  background: "linear-gradient(to top, rgba(150,100,15,0.88) 0%, rgba(201,168,76,0.5) 30%, rgba(201,168,76,0.08) 65%, transparent 100%)",
                  pointerEvents: "none",
                }} />
                {/* linie aurie strălucitoare la bază */}
                <div style={{
                  position: "absolute", bottom: 0, left: 0, right: 0,
                  height: 2,
                  background: "linear-gradient(to right, transparent 0%, rgba(240,200,80,0.4) 15%, rgba(255,225,110,0.95) 50%, rgba(240,200,80,0.4) 85%, transparent 100%)",
                  pointerEvents: "none",
                }} />
              </div>
              {/* glow auriu difuz sub imagine */}
              <div style={{
                position: "absolute", bottom: -20, left: "8%", right: "8%",
                height: 28,
                background: "radial-gradient(ellipse at center, rgba(201,168,76,0.4) 0%, transparent 70%)",
                filter: "blur(10px)",
                pointerEvents: "none",
              }} />
              {!isMobile && (
                <div style={{
                  position: "absolute", bottom: -14, right: -14,
                  width: 120, height: 120,
                  border: "1px solid rgba(201,168,76,0.25)",
                  borderRadius: 3, zIndex: -1,
                }} />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="wip-page">
          <ArchitecturalGrid />
          <div className="wip-icon"><svg viewBox="0 0 24 24"><path d="M12 6v6l4 2" /><circle cx="12" cy="12" r="10" /></svg></div>
          <div className="wip-title">Pagină în lucru</div>
          <div className="wip-sub">Revenim în curând cu conținut nou</div>
        </div>
      )}

      <footer>
        <div className="footer-bar">
          <div className="footer-inner">
            <div className="footer-cols">
              <div className="footer-col">
                <div className="footer-item">
                  <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" /><circle cx="12" cy="9" r="2.5" /></svg>
                  <span>Șos. Chitilei, Nr. 413<br />Sector 1, București</span>
                </div>
              </div>
              <div className="footer-col">
                <div className="footer-item">
                  <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                  <a href="mailto:contact@alsofthome.ro">info@alsofthome.ro</a>
                </div>
              </div>
              <div className="footer-col">
                <div className="footer-item">
                  <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.07 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" /></svg>
                  <a href="tel:+40770300633">+40 770 300 633</a>
                  <a href="tel:+40768939986">+40 768 939 986</a>
                </div>
              </div>
            </div>
            <div className="footer-divider" />
            <div className="footer-bottom">
              <span className="footer-copy">© 2026 AL SOFT HOME. Toate drepturile rezervate.</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
